import { css, jsx, withEmotionCache, ThemeContext } from '@emotion/react';
import React, { memo, useState, useEffect, Fragment as Fragment$1, useContext, createElement, Component, createRef, useRef } from 'react';
import { useTheme, useThemeProps, withThemeProps } from '@findep/microfronts-core';
import Fab from '@material-ui/core/Fab';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { Box, Typography, Grid, Slider, Modal, Tooltip, Button, FormControl, InputLabel, Select as Select$1, TextField, InputAdornment, IconButton, FormLabel, FormHelperText } from '@material-ui/core';
import RemoveIcon from '@material-ui/icons/Remove';
import AddIcon from '@material-ui/icons/Add';
import { withStyles, makeStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepConnector from '@material-ui/core/StepConnector';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import CreateIcon from '@material-ui/icons/Create';
import PublishIcon from '@material-ui/icons/Publish';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import { ErrorOutline, AttachMoney, Publish, InfoOutlined, AssignmentInd, Warning } from '@material-ui/icons';
import InputLabel$1 from '@material-ui/core/InputLabel';
import FormControl$1 from '@material-ui/core/FormControl';
import Select$2 from '@material-ui/core/Select';
import Button$1 from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import '@material-ui/system';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Grid$1 from '@material-ui/core/Grid';
import Box$1 from '@material-ui/core/Box';
import Typography$1 from '@material-ui/core/Typography';
import PersonIcon from '@material-ui/icons/Person';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CircularProgress from '@material-ui/core/CircularProgress';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TextField$1 from '@material-ui/core/TextField';
import { parse, isValid, format } from 'date-fns';
import FormHelperText$1 from '@material-ui/core/FormHelperText';
import FormLabel$1 from '@material-ui/core/FormLabel';
import Slider$1 from '@material-ui/core/Slider';
import IconButton$1 from '@material-ui/core/IconButton';
import ControlPointIcon from '@material-ui/icons/ControlPoint';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import MenuItem from '@material-ui/core/MenuItem';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}
function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = "function" === typeof Symbol && Symbol.for,
  c = b ? Symbol.for("react.element") : 60103,
  d = b ? Symbol.for("react.portal") : 60106,
  e = b ? Symbol.for("react.fragment") : 60107,
  f = b ? Symbol.for("react.strict_mode") : 60108,
  g = b ? Symbol.for("react.profiler") : 60114,
  h = b ? Symbol.for("react.provider") : 60109,
  k = b ? Symbol.for("react.context") : 60110,
  l = b ? Symbol.for("react.async_mode") : 60111,
  m = b ? Symbol.for("react.concurrent_mode") : 60111,
  n = b ? Symbol.for("react.forward_ref") : 60112,
  p = b ? Symbol.for("react.suspense") : 60113,
  q = b ? Symbol.for("react.suspense_list") : 60120,
  r = b ? Symbol.for("react.memo") : 60115,
  t = b ? Symbol.for("react.lazy") : 60116,
  v = b ? Symbol.for("react.block") : 60121,
  w = b ? Symbol.for("react.fundamental") : 60117,
  x = b ? Symbol.for("react.responder") : 60118,
  y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m;
}
var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;
var isAsyncMode = function isAsyncMode(a) {
  return A(a) || z(a) === l;
};
var isConcurrentMode = A;
var isContextConsumer = function isContextConsumer(a) {
  return z(a) === k;
};
var isContextProvider = function isContextProvider(a) {
  return z(a) === h;
};
var isElement = function isElement(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};
var isForwardRef = function isForwardRef(a) {
  return z(a) === n;
};
var isFragment = function isFragment(a) {
  return z(a) === e;
};
var isLazy = function isLazy(a) {
  return z(a) === t;
};
var isMemo = function isMemo(a) {
  return z(a) === r;
};
var isPortal = function isPortal(a) {
  return z(a) === d;
};
var isProfiler = function isProfiler(a) {
  return z(a) === g;
};
var isStrictMode = function isStrictMode(a) {
  return z(a) === f;
};
var isSuspense = function isSuspense(a) {
  return z(a) === p;
};
var isValidElementType = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};
var reactIs_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' ||
        // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }

    // Detect buggy property enumeration order in older V8 versions.

    // https://bugs.chromium.org/p/v8/issues/detail?id=4118
    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;
var printWarning = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);
  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes;
var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$1 = function printWarning$1() {};
if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function printWarning$1(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] &&
          // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  } // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs;

    // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
});
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var FullWidth = "\n  width: 100vw;\n  max-width: 100vw;\n";
var MainScreen = "\n  position: absolute;\n  overflow: hidden;\n  display: flex;\n  " + FullWidth + "\n";
function MenuLayout(_ref) {
  var children = _ref.children,
    menuElement = _ref.menuElement,
    menuElementLeft = _ref.menuElementLeft;
  var _useTheme = useTheme(),
    palette = _useTheme.palette;
  var _useState = useState('100vh'),
    height = _useState[0],
    setHeight = _useState[1];
  var FullHeight = "\n    height: " + height + ";\n    max-height: " + height + ";\n  ";
  var MainHeight = "\n    height: calc(" + height + " - 1.5rem);\n    max-height: calc(" + height + " - 1.5rem);\n  ";
  var FullScreen = "\n    " + MainScreen + "\n    " + FullHeight + "\n  ";
  var Background = css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    ", "\n    z-index: 0;\n    flex-direction: column;\n    justify-content: flex-start;\n    background-color: ", ";\n  "])), FullScreen, palette.layout ? palette.layout.header : 'white');
  var PrincipalLayer = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    z-index: 0;\n    flex-direction: column;\n    justify-content: flex-end;\n    bottom: 0;\n  "])), MainScreen, MainHeight);
  var MenuNav = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    width: 100%;\n    max-width: 100%;\n    min-height: 2rem;\n  "])));
  var Main = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n    z-index: 1 !important;\n    overflow: hidden;\n    ", "\n    ", "\n  "])), MainHeight, MainScreen);
  var Header = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n    position: fixed;\n    z-index: 15 !important;\n    width: 100%;\n    max-width: 100%;\n    min-height: 2rem;\n    top: 0;\n    left: 0;\n  "])));
  var divcontenedor = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n  "])));
  var divright = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: flex;\n    justify-content: flex-end;\n    width: 100%;\n  "])));
  var divleft = css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: flex;\n    justify-content: flex-start;\n    width: 100%;\n  "])));
  useEffect(function () {
    if (typeof window !== 'undefined') {
      var _window = window,
        ResizeObserver = _window.ResizeObserver;
      var realViewPortHeight = window.innerHeight + "px";
      setHeight(realViewPortHeight);
      var resizeObserver = new ResizeObserver(function (_entries) {
        return setHeight(window.innerHeight + "px");
      });
      resizeObserver.observe(window.document.body);
    }
  }, []);
  return jsx(Fragment$1, null, jsx("div", {
    css: Background
  }), jsx("div", {
    css: PrincipalLayer
  }, jsx("section", {
    css: Main
  }, children), menuElement ? jsx("header", {
    css: Header
  }, jsx("nav", null, jsx("div", {
    css: divcontenedor
  }, menuElementLeft && jsx("div", {
    css: divleft
  }, menuElementLeft), jsx("div", {
    css: divright
  }, menuElement)))) : null));
}
MenuLayout.propTypes = {
  children: propTypes.element.isRequired,
  menuElement: propTypes.element,
  menuElementLeft: propTypes.element
};
var MenuLayout$1 = memo(MenuLayout);
var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1;
var _excluded = ["textButton", "onClick", "icon", "disabled", "id", "monocromatico"];
function ButtonDegrade(inProps) {
  var props = useThemeProps({
    props: inProps,
    name: 'MFButtonDegrade'
  });
  var _props$textButton = props.textButton,
    textButton = _props$textButton === void 0 ? 'Continuar con solicitud' : _props$textButton,
    _props$onClick = props.onClick,
    onClick = _props$onClick === void 0 ? function () {} : _props$onClick,
    _props$icon = props.icon,
    icon = _props$icon === void 0 ? ArrowForwardIcon : _props$icon,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$id = props.id,
    id = _props$id === void 0 ? 'degrade' : _props$id,
    _props$monocromatico = props.monocromatico,
    monocromatico = _props$monocromatico === void 0 ? false : _props$monocromatico,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  var _useTheme = useTheme(),
    palette = _useTheme.palette;
  var Icon = icon;
  var colorDisabled = css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n  "])), palette.text.disabled);
  var iconColor = css(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n    ", "\n  "])), monocromatico ? 'color:#a5a5a5;' : disabled ? colorDisabled : "color: white;");
  var h1Color = css(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n    ", "\n  "])), monocromatico ? 'background: rgba(255, 0, 0, 0.3);' : disabled ? colorDisabled : "background: linear-gradient(" + palette.primary.light + ", " + palette.primary.main + ")");
  var h1Style = css(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n    ", "\n    color: 'white';\n    ", "\n  "])), monocromatico && 'box-shadow: none!important;', h1Color);
  var TextC = css(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n    font-weight: bold;\n    line-height: 1.5;\n    letter-spacing: 0.00938em;\n  "])), monocromatico ? 'color: #a5a5a5;' : disabled ? colorDisabled : "color: white;", monocromatico ? 'font-size: 0.7rem;' : 'font-size: 1rem;');
  var iconStyle = css(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteralLoose(["\n    ", "\n    position: relative;\n    margin-right: 0.3em;\n    ", "\n  "])), monocromatico && 'font-size: 1.3rem!important;', iconColor);
  return jsx(Fab, _extends({
    id: id + "-button",
    variant: "extended",
    onClick: onClick,
    disabled: disabled,
    css: h1Style
  }, otherProps), icon ? jsx(Icon, {
    css: iconStyle
  }) : '', jsx("span", {
    css: TextC,
    id: id + "-span"
  }, textButton));
}
ButtonDegrade.propTypes = {
  textButton: propTypes.string.isRequired,
  id: propTypes.string,
  onClick: propTypes.func,
  icon: propTypes.object,
  disabled: propTypes.bool,
  monocromatico: propTypes.bool
};
var integerFormat = function integerFormat(num, separation, separator) {
  if (num.length > separation) {
    var tmp = num.split('');
    var first = num.length % separation;
    var blocks = parseInt(num.length / separation);
    var sections = [tmp.slice(0, first).join('')];
    for (var i = 0; i < blocks; i++) {
      sections = [].concat(sections, [tmp.slice(i * separation + first, (i + 1) * separation + first).join('')]);
    }
    return sections.filter(function (segmento) {
      return segmento !== '';
    }).join(separator);
  } else return num;
};
var formatNumber = function formatNumber(num, separation, separator, simbol, decimals, decimalSeparator) {
  if (separation === void 0) {
    separation = 3;
  }
  if (separator === void 0) {
    separator = ',';
  }
  if (simbol === void 0) {
    simbol = '$';
  }
  if (decimals === void 0) {
    decimals = 2;
  }
  var number = Number(num).toFixed(decimals).split('.');
  return simbol + " " + integerFormat(number[0].replace(/\s/g, ''), separation, separator);
};
var _templateObject$2, _templateObject2$2, _templateObject3$2, _templateObject4$2, _templateObject5$2, _templateObject6$2, _templateObject7$1;
function SliderRange(props) {
  var _useTheme = useTheme(),
    palette = _useTheme.palette;
  var principal = css(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n    min-width: 100% !important;\n    width:100%!important\n  "])));
  var root = css(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n  margin-left: 0.5rem!important;\n    color: ", " !important;\n    & span {\n      ", "\n    }\n    ", "\n  "])), palette.primary.main, props.disabled ? 'color: rgba(0, 0, 0, 0.38) !important;' : 'color: ${palette.primary.main} !important;', props.disabled && 'color: rgba(0, 0, 0, 0.38) !important;');
  var styleSlider = css(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n  "])), palette.primary.main);
  var rootDisplayMount = css(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteralLoose(["\n    margin-bottom: 0 !important;\n    font-weight: bold !important;\n    ", "\n  "])), props.disabled && 'color: rgba(0, 0, 0, 0.38) !important;');
  var generalIcons = css(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteralLoose(["\n    color: white;\n    background: ", ";\n    border-radius: 50%;\n    width: 1rem !important;\n    height: 1rem !important;\n  "])), palette.primary.main);
  var disabledIcons = css(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteralLoose(["\n    pointer-events: none;\n    color: rgba(0, 0, 0, 0.38);\n    background-color: rgba(0, 0, 0, 0.12);\n    border-radius: 50%;\n    width: 1rem !important;\n    height: 1rem !important;\n  "])));
  var styleIcons = css(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteralLoose(["\n    cursor: pointer;\n    ", "\n  "])), props.disabled ? disabledIcons : generalIcons);
  var _useState = useState({
      max: props.max,
      min: props.min,
      step: props.step,
      defaultValue: props.defaultValue
    }),
    state = _useState[0],
    setState = _useState[1];
  var _useState2 = useState(props.rangeValues ? 0 : props.min),
    mount = _useState2[0],
    setMount = _useState2[1];
  var _useState3 = useState(props.rangeValues ? 0 : props.min),
    aux = _useState3[0],
    setAux = _useState3[1];
  useEffect(function () {
    var max = props.rangeValues ? props.rangeValues.length - 1 : props.max;
    var min = props.rangeValues ? 0 : props.min;
    if (props.rangeValues) {
      max = props.rangeValues.length - 1;
      min = 0;
      setState({
        max: max,
        min: min,
        step: 1,
        defaultValue: props.defaultValue
      });
    }
    if (state.defaultValue) {
      if (state.defaultValue >= min && state.defaultValue <= max) {
        setMount(state.defaultValue);
        setAux(state.defaultValue);
      } else {
        throw new Error('defautValue no respeta los limites max/min o no coincide con steper code Mount');
      }
    }
  }, []);
  useEffect(function () {
    var max = props.rangeValues ? props.rangeValues.length - 1 : props.max;
    var min = props.rangeValues ? 0 : props.min;
    if (props.rangeValues) {
      setState({
        max: max,
        min: min,
        step: 1,
        defaultValue: props.defaultValue
      });
    } else {
      setState({
        max: max,
        min: min,
        step: props.step,
        defaultValue: props.defaultValue
      });
    }
    if (props.defaultValue) {
      if (props.defaultValue >= min && props.defaultValue <= max) {
        setMount(props.defaultValue);
        setAux(props.defaultValue);
      } else {
        throw new Error('defautValue no respeta los limites max/min o no coincide con steper code Update');
      }
    } else {
      setMount(min);
      setAux(min);
    }
  }, [props.min, props.max, props.defaultValue, props.rangeValues]);
  useEffect(function () {
    props.onChange({
      mount: mount
    });
  }, [mount]);
  var handleSliderChange = function handleSliderChange(_event, newValue) {
    setMount(newValue);
    setAux(newValue);
  };
  var handleChangeMount = function handleChangeMount(flag) {
    var newMount = Number(flag) + aux;
    if (flag < 0) {
      if (aux >= state.min) {
        if (newMount >= state.min) {
          setMount(newMount);
          setAux(newMount);
        } else {
          if (!(aux === state.min)) {
            setMount(state.min);
            setAux(newMount);
          }
        }
      }
    } else {
      if (aux <= state.max) {
        if (newMount <= state.max) {
          setMount(newMount);
          setAux(newMount);
        } else {
          if (!(aux === state.max)) {
            setMount(state.max);
            setAux(newMount);
          }
        }
      }
    }
  };
  return jsx(Box, {
    css: principal
  }, jsx(Typography, {
    id: "displayMount",
    gutterBottom: true,
    color: "secondary",
    variant: "h4",
    fontFamily: "roboto",
    css: rootDisplayMount,
    fontWeight: "fontWeightBold",
    align: "center"
  }, jsx(Box, {
    textAlign: "center"
  }, props.alternalText ? props.alternalText : formatNumber(props.rangeValues ? props.rangeValues[mount] : mount))), jsx(Grid, {
    container: true,
    spacing: 1,
    alignItems: "center",
    justify: "center"
  }, jsx(Grid, {
    item: true,
    xs: 1
  }, jsx(RemoveIcon, {
    id: props.id + "-BtnMinus-button",
    onClick: function onClick() {
      return handleChangeMount(-state.step);
    },
    css: styleIcons
  })), jsx(Grid, {
    item: true,
    xs: 8,
    css: root
  }, jsx(Slider, {
    css: styleSlider,
    id: props.id + "-input",
    value: typeof mount !== 'number' ? state.min : mount,
    step: state.step,
    max: state.max,
    min: state.min,
    onChange: handleSliderChange,
    "aria-labelledby": "input-slider",
    disabled: props.disabled
  })), jsx(Grid, {
    item: true,
    xs: 1
  }, jsx(AddIcon, {
    id: props.id + "-BtnPlus-button",
    onClick: function onClick() {
      return handleChangeMount(state.step);
    },
    css: styleIcons
  }))));
}
SliderRange.propTypes = {
  max: propTypes.number,
  min: propTypes.number,
  step: propTypes.number,
  defaultValue: propTypes.number,
  disabled: propTypes.bool,
  onChange: propTypes.func,
  id: propTypes.string,
  alternalText: propTypes.node,
  rangeValues: propTypes.array
};
SliderRange.defaultProps = {
  max: 100,
  min: 10,
  step: 10,
  disabled: false,
  onChange: function onChange() {},
  id: 'slider-range'
};
var _templateObject$3, _templateObject2$3, _templateObject3$3;
var InputNip = function InputNip(inProps) {
  var props = useThemeProps({
    props: inProps,
    name: 'MFInputNip'
  });
  var _props$length = props.length,
    length = _props$length === void 0 ? 6 : _props$length,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
    _props$id = props.id,
    id = _props$id === void 0 ? 'input-nip' : _props$id,
    _props$emitForever = props.emitForever,
    emitForever = _props$emitForever === void 0 ? false : _props$emitForever;
  var _useTheme = useTheme(),
    palette = _useTheme.palette;
  var divContainer = css(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: center;\n  "])));
  var root = css(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteralLoose(["\n    max-width: 2rem !important;\n    max-height: 3rem !important;\n    width: 2rem;\n    height: 3rem !important;\n    margin-right: 0.5rem;\n    text-align: center;\n    font-size: x-large;\n    border-radius: 0.5rem;\n    border: solid 1px #979797;\n    background-color: #f5f5f5;\n    &:focus {\n      outline: none;\n    }\n    &:focus,\n    &:hover {\n      border-color: ", ";\n    }\n  "])), palette.primary.main);
  var rootspace = css(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteralLoose(["\n    margin-right: 1.5rem !important;\n  "])));
  var _useState = useState([]),
    values = _useState[0],
    setValues = _useState[1];
  var _useState2 = useState([]),
    refs = _useState2[0],
    setRefs = _useState2[1];
  useEffect(function () {
    var arrayRefs = [].concat(refs);
    var arrayValues = [].concat(values);
    for (var index = 0; index < length; index++) {
      arrayRefs = [].concat(arrayRefs, [(id || '') + "-" + index + "-input"]);
      arrayValues = [].concat(arrayValues, ['']);
    }
    setValues(arrayValues);
    setRefs(arrayRefs);
  }, []);
  function getValues() {
    return refs.map(function (item) {
      return document.getElementById(item).value;
    });
  }
  useEffect(function () {
    var value = getValues().join('');
    if (value.length === length || emitForever && value !== "") {
      onChange({
        value: value
      });
    }
  }, [values]);
  function _handleInput(event, index) {
    var arrayValues = getValues();
    arrayValues[index] = String(event.target.value).replace(/[^0-9]/g, '').substring(0, 1);
    event.target.value = arrayValues[index] + '';
    if (index + 1 < length && arrayValues[index] !== '') {
      var next = refs[index + 1];
      typeof window !== 'undefined' && window.document.getElementById(next).focus();
    } else {
      typeof window !== 'undefined' && window.document.getElementById(refs[index]).blur();
    }
    var value = getValues().join('');
    setValues(value);
  }
  function _handleFocus(event, index) {
    var arrayValues = getValues();
    arrayValues[index] = '';
    event.target.value = '';
    var value = getValues().join('');
    setValues(value);
  }
  return jsx("div", {
    css: divContainer
  }, refs.map(function (uuid, index) {
    return jsx("input", {
      id: uuid,
      key: uuid,
      type: "text",
      inputMode: "numeric",
      css: [root, index % 2 !== 0 ? rootspace : null],
      defaultValue: values[index],
      disabled: disabled,
      onFocus: function onFocus(e) {
        return _handleFocus(e, index);
      },
      onInput: function onInput(e) {
        return _handleInput(e, index);
      }
    });
  }));
};
InputNip.propTypes = {
  length: propTypes.number,
  disabled: propTypes.bool,
  onChange: propTypes.func,
  id: propTypes.string,
  emitForever: propTypes.bool,
  space: propTypes.number
};
var _templateObject$4, _templateObject2$4, _templateObject3$4, _templateObject4$3, _templateObject5$3, _templateObject6$3, _templateObject7$2, _templateObject8$1, _templateObject9, _templateObject10;
function ModalInfo(inProps) {
  var _palette$props$btnLef, _palette$props$btnRig, _props$toolTipButtonL, _props$toolTipButtonR;
  var _useTheme = useTheme(),
    palette = _useTheme.palette;
  var props = useThemeProps({
    props: inProps,
    name: 'MFModalInfo'
  });
  var _props$open = props.open,
    openModal = _props$open === void 0 ? true : _props$open,
    title = props.title,
    body = props.body,
    btnLeft = props.btnLeft,
    btnRight = props.btnRight,
    _props$btnLeftColor = props.btnLeftColor,
    btnLeftColor = _props$btnLeftColor === void 0 ? '' : _props$btnLeftColor,
    _props$btnRightColor = props.btnRightColor,
    btnRightColor = _props$btnRightColor === void 0 ? '' : _props$btnRightColor,
    _props$buttonPadding = props.buttonPadding,
    buttonPadding = _props$buttonPadding === void 0 ? true : _props$buttonPadding,
    _props$icon = props.icon,
    icon = _props$icon === void 0 ? null : _props$icon,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
    _props$disableBackdro = props.disableBackdropClick,
    disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
    _props$autoClose = props.autoClose,
    autoClose = _props$autoClose === void 0 ? true : _props$autoClose,
    _props$onClose = props.onClose,
    onClose = _props$onClose === void 0 ? function () {} : _props$onClose,
    _props$color = props.color,
    color = _props$color === void 0 ? 'secondary' : _props$color,
    _props$colorText = props.colorText,
    colorText = _props$colorText === void 0 ? 'white' : _props$colorText,
    _props$buttonJustify = props.buttonJustify,
    buttonJustify = _props$buttonJustify === void 0 ? 'center' : _props$buttonJustify,
    _props$buttonAlignCon = props.buttonAlignContent,
    buttonAlignContent = _props$buttonAlignCon === void 0 ? 'flex-end' : _props$buttonAlignCon,
    _props$marginBottom = props.marginBottom,
    marginBottom = _props$marginBottom === void 0 ? '1rem' : _props$marginBottom,
    _props$id = props.id,
    id = _props$id === void 0 ? 'info-modal' : _props$id;
  var desactiveButtonLeft = btnLeftColor === 'primary' || 'secondary' || 'warning' || 'error' || 'success' || 'info' ? (_palette$props$btnLef = palette[props.btnLeftColor]) === null || _palette$props$btnLef === void 0 ? void 0 : _palette$props$btnLef.main : btnLeftColor;
  var desactiveButtonRight = btnRightColor === 'primary' || 'secondary' || 'warning' || 'error' || 'success' || 'info' ? (_palette$props$btnRig = palette[props.btnRightColor]) === null || _palette$props$btnRig === void 0 ? void 0 : _palette$props$btnRig.main : btnRightColor;
  var principal = css(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    &:focus {\n      border: none;\n    }\n  "])));
  var root = css(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteralLoose(["\n    background: white;\n    width: 90% !important;\n    margin: auto !important;\n    border-radius: 30px;\n    overflow: hidden;\n    min-height: 239px !important;\n    ", "\n  "])), props.rootCss && props.rootCss);
  var titleModal = css(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteralLoose(["\n    min-height: 54px;\n    background: ", ";\n    height: 54px;\n    color: ", ";\n  "])), props.backgroundModal || palette[color].main, colorText);
  var bodyStyle = css(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteralLoose(["\n    text-align: center;\n    margin-top: 2rem !important;\n    padding: 1.5rem;\n    font-size: 14px;\n  "])));
  var iconStile = css(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteralLoose(["\n    padding-top: 0.8rem;\n    display: flex;\n    align-items: center;\n  "])));
  var bodyContainer = css(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteralLoose(["\n    min-height: 185px;\n  "])));
  var btnLeftCss = css(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteralLoose(["\n    color: ", " !important;\n  "])), props.btnLeftColor && !props.btnLeftDisabled ? desactiveButtonLeft : 'rgba(0, 0, 0, 0.23)');
  var btnRightCss = css(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n  "])), props.btnRightColor && !props.btnRightDisabled ? desactiveButtonRight : '');
  var buttonPaddingCss = css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n    padding-left: 1.3em;\n    padding-right: 1.3em;\n  "])));
  var buttonContent = css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n    margin-bottom: ", " !important;\n    ", "\n  "])), marginBottom, buttonPadding ? buttonPaddingCss : '');
  var Icon = icon;
  var _useState = useState(openModal),
    open = _useState[0],
    setOpen = _useState[1];
  useEffect(function () {
    setOpen(props.open);
  }, [props.open]);
  var handleClose = function handleClose() {
    if (autoClose) {
      setOpen(false);
    }
    onClose({
      value: open
    });
  };
  var handleClick = function handleClick(flag) {
    if (autoClose) {
      setOpen(false);
    }
    onChange({
      value: flag
    });
  };
  return jsx(Fragment$1, null, jsx(Modal, {
    id: id + "-modal",
    open: open,
    onClose: handleClose,
    "aria-labelledby": "modal-title",
    "aria-describedby": "modal-description",
    css: principal,
    disableEnforceFocus: true,
    disableAutoFocus: true,
    disableBackdropClick: disableBackdropClick
  }, jsx("div", {
    css: root
  }, jsx(Grid, {
    container: true,
    spacing: 2,
    justify: "center",
    css: titleModal
  }, jsx(Grid, {
    item: true,
    css: iconStile
  }, icon && jsx(Icon, null)), jsx(Grid, {
    item: true
  }, jsx(Typography, {
    css: iconStile,
    gutterBottom: true,
    variant: "h5",
    fontFamily: "roboto",
    fontWeight: "fontWeightBold"
  }, title))), jsx(Grid, {
    container: true,
    spacing: 2,
    justify: "center",
    css: bodyContainer
  }, jsx(Typography, {
    id: id + "-modal-body",
    gutterBottom: true,
    component: "div",
    variant: "body1",
    fontFamily: "roboto",
    fontWeight: "fontWeightBold",
    css: bodyStyle
  }, body), jsx(Grid, {
    container: true,
    spacing: 2,
    justify: buttonJustify,
    alignContent: buttonAlignContent,
    css: buttonContent
  }, btnLeft && jsx(Grid, {
    item: true
  }, jsx(Tooltip, {
    title: (_props$toolTipButtonL = props.toolTipButtonLeft) != null ? _props$toolTipButtonL : '',
    placement: "top"
  }, jsx(Button, {
    id: id + "-" + btnLeft + "-button",
    css: btnLeftCss,
    disabled: props.btnLeftDisabled,
    onClick: function onClick() {
      return handleClick("" + btnLeft);
    },
    variant: props.backgroundButton && 'contained',
    color: props.backgroundButton && props.color,
    style: {
      background: props.backgroundButtonColor
    }
  }, btnLeft))), btnRight && jsx(Grid, {
    item: true
  }, jsx(Tooltip, {
    title: (_props$toolTipButtonR = props.toolTipButtonRight) != null ? _props$toolTipButtonR : '',
    placement: "top"
  }, jsx(Button, {
    id: id + "-" + props.btnRight + "-button",
    css: btnRightCss,
    disabled: props.btnRightDisabled,
    variant: props.backgroundButton && 'contained',
    color: props.backgroundButton && props.color,
    style: {
      background: props.backgroundButtonColor
    },
    onClick: function onClick() {
      return handleClick("" + props.btnRight);
    }
  }, btnRight))))))));
}
ModalInfo.propTypes = {
  open: propTypes.bool,
  title: propTypes.string,
  colorText: propTypes.string,
  btnLeft: propTypes.any,
  backgroundButton: propTypes["true"],
  btnLeftDisabled: propTypes.bool,
  btnLeftColor: propTypes.string,
  backgroundButtonColor: propTypes.string,
  btnRight: propTypes.any,
  btnRightDisabled: propTypes.bool,
  btnRightColor: propTypes.string,
  body: propTypes.any,
  icon: propTypes.object,
  onChange: propTypes.func,
  color: propTypes.string,
  disableBackdropClick: propTypes.bool,
  autoClose: propTypes.bool,
  onClose: propTypes.func,
  buttonJustify: propTypes.string,
  buttonAlignContent: propTypes.string,
  toolTipButtonLeft: propTypes.string,
  toolTipButtonRight: propTypes.string,
  backgroundModal: propTypes.string,
  buttons: propTypes.node,
  buttonPadding: propTypes.bool,
  marginBottom: propTypes.string,
  id: propTypes.string,
  rootCss: propTypes.string
};
var _templateObject$5, _templateObject2$5, _templateObject3$5, _templateObject4$4, _templateObject5$4, _templateObject6$4;
var _excluded$1 = ["icon", "label", "options", "altText", "disabled", "onChange", "fullWidth", "colorIcon", "marginIcon", "sizeIcon", "id", "iconProps", "color", "variant", "size"];
function SelectIcon(_ref) {
  var icon = _ref.icon,
    label = _ref.label,
    options = _ref.options,
    altText = _ref.altText,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    fullWidth = _ref.fullWidth,
    colorIcon = _ref.colorIcon,
    marginIcon = _ref.marginIcon,
    sizeIcon = _ref.sizeIcon,
    id = _ref.id,
    iconProps = _ref.iconProps,
    color = _ref.color,
    variant = _ref.variant,
    size = _ref.size,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var _useTheme = useTheme(),
    palette = _useTheme.palette;
  var root = css(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    display: flex;\n  "])));
  var iconRoot = css(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    ", "\n    ", "\n  "])), colorIcon ? 'none' : 'rgba(0,0,0,0.26)', sizeIcon ? 'font-size:' + sizeIcon : 'font-size: 2.2rem !important;', marginIcon || 'margin-right: 0.5rem;  margin-left: 0.5rem;  margin-top: 0.8rem;');
  var containerSelct = css(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    ", "\n  "])), fullWidth ? 'width: 95% !important;' : 'width: 70% !important;');
  var cssAltText = css(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteralLoose(["\n    color: rgba(0, 0, 0, 0.54);\n    padding-left: 5px;\n    font-size: 12px !important;\n    line-height: 1.67;\n    letter-spacing: 0.4px;\n  "])));
  var selectCss = css(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteralLoose(["\n    & .MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline {\n      border-color: ", " !important;\n      border: 2px;\n    }\n  "])), palette.primary.main);
  var divEmpty = css(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteralLoose(["\n    min-width: 35.19px;\n    margin-left: 1rem;\n    margin-right: 1rem;\n  "])));
  var Icon = icon;
  var handleChange = function handleChange(e) {
    var value = e.target.value;
    onChange({
      value: value
    });
  };
  return jsx("div", {
    css: root
  }, icon !== null ? jsx(Icon, _extends({
    css: iconRoot
  }, iconProps)) : jsx("div", {
    css: divEmpty
  }, " "), jsx("div", {
    css: containerSelct
  }, jsx(FormControl, {
    variant: variant,
    size: size
  }, jsx(InputLabel, {
    htmlFor: "outlined-age-native-simple"
  }, label), jsx(Select$1, _extends({
    id: id + "-select",
    fullWidth: fullWidth,
    css: selectCss,
    color: color,
    "native": true,
    label: label,
    disabled: disabled,
    onChange: handleChange
  }, otherProps), jsx("option", {
    "aria-label": "None",
    value: ""
  }), options.map(function (item, index) {
    return jsx("option", {
      key: index,
      value: item.key
    }, item.value);
  }))), altText && jsx(Typography, {
    css: cssAltText
  }, " ", altText, " ")));
}
SelectIcon.propTypes = {
  icon: propTypes.object,
  label: propTypes.string,
  options: propTypes.array,
  altText: propTypes.string,
  disabled: propTypes.bool,
  onChange: propTypes.func.isRequired,
  fullWidth: propTypes.bool,
  colorIcon: propTypes.bool,
  sizeIcon: propTypes.string,
  marginIcon: propTypes.string,
  id: propTypes.string,
  color: propTypes.string,
  variant: propTypes.string,
  size: propTypes.string
};
SelectIcon.defaultProps = {
  icon: null,
  label: 'example',
  options: [{
    key: 'mdn',
    value: 'example1'
  }, {
    key: 'mlb',
    value: 'example2'
  }, {
    key: 'kmc',
    value: 'example3'
  }],
  disabled: false,
  fullWidth: false,
  id: 'select-icon',
  color: 'primary',
  onChange: function onChange() {},
  variant: 'outlined'
};
function toVal(mix) {
  var k,
    y,
    str = '';
  if (typeof mix === 'string' || typeof mix === 'number') {
    str += mix;
  } else if (typeof mix === 'object') {
    if (Array.isArray(mix)) {
      for (k = 0; k < mix.length; k++) {
        if (mix[k]) {
          if (y = toVal(mix[k])) {
            str && (str += ' ');
            str += y;
          }
        }
      }
    } else {
      for (k in mix) {
        if (mix[k]) {
          str && (str += ' ');
          str += k;
        }
      }
    }
  }
  return str;
}
function clsx() {
  var i = 0,
    tmp,
    x,
    str = '';
  while (i < arguments.length) {
    if (tmp = arguments[i++]) {
      if (x = toVal(tmp)) {
        str && (str += ' ');
        str += x;
      }
    }
  }
  return str;
}
function CustomizedSteppers(inProps) {
  var props = useThemeProps({
    props: inProps,
    name: 'MFCustomizedStepper'
  });
  var _useTheme = useTheme(),
    palette = _useTheme.palette;
  var _props$currentStep = props.currentStep,
    currentStep = _props$currentStep === void 0 ? 0 : _props$currentStep,
    _props$iconos = props.iconos,
    iconos = _props$iconos === void 0 ? {
      1: /*#__PURE__*/React.createElement(PublishIcon, null),
      2: /*#__PURE__*/React.createElement(HowToRegIcon, null),
      3: /*#__PURE__*/React.createElement(CreateIcon, null),
      4: /*#__PURE__*/React.createElement(AttachMoneyIcon, null)
    } : _props$iconos,
    _props$texts = props.texts,
    texts = _props$texts === void 0 ? [{
      texto: 'DOCUMENTOS'
    }, {
      texto: 'REFERENCIAS'
    }, {
      texto: 'FIRMA DIGITAL'
    }, {
      texto: 'CONFIRMACIÓN'
    }] : _props$texts,
    _props$movil = props.movil,
    movil = _props$movil === void 0 ? false : _props$movil,
    _props$altoPerfil = props.altoPerfil,
    altoPerfil = _props$altoPerfil === void 0 ? false : _props$altoPerfil,
    _props$customizedColo = props.customizedColor,
    customizedColor = _props$customizedColo === void 0 ? palette.primary.main : _props$customizedColo;
  var matches = useMediaQuery('(min-width:600px)');
  var _React$useState = React.useState(currentStep),
    activeStep = _React$useState[0];
  var steps = getSteps(texts);
  var ColorlibConnector = withStyles({
    alternativeLabel: {
      top: 22
    },
    active: {
      '& $line': {
        backgroundImage: "linear-gradient(0deg, " + (customizedColor || palette.primary.main) + " 1%, " + (customizedColor || palette.primary.main) + " 48%, " + (customizedColor || palette.primary.main) + " 100%)"
      }
    },
    completed: {
      '& $line': {
        backgroundImage: "linear-gradient(0deg, " + (customizedColor || palette.primary.main) + " 1%, " + (customizedColor || palette.primary.main) + " 48%, " + (customizedColor || palette.primary.main) + " 100%)"
      }
    },
    line: {
      height: 3,
      border: 0,
      backgroundColor: "#ccc",
      borderRadius: 1
    }
  })(StepConnector);
  var useColorlibStepIconStyles = makeStyles({
    root: {
      backgroundColor: '#ccc',
      zIndex: 1,
      color: '#fff',
      width: 50,
      height: 50,
      display: 'flex',
      borderRadius: '50%',
      justifyContent: 'center',
      alignItems: 'center'
    },
    rootButton: {
      backgroundColor: '#ccc',
      zIndex: 1,
      color: '#fff'
    },
    active: {
      backgroundImage: "linear-gradient(0deg, " + (customizedColor || palette.primary.main) + " 1%, " + (customizedColor || palette.primary.main) + " 48%, " + (customizedColor || palette.primary.main) + " 100%)",
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)'
    },
    completed: {
      backgroundImage: "linear-gradient(0deg, " + (customizedColor || palette.primary.main) + " 1%, " + (customizedColor || palette.primary.main) + " 48%, " + (customizedColor || palette.primary.main) + " 100%)"
    }
  });
  function ColorlibStepIcon(props) {
    var _clsx;
    var classes = useColorlibStepIconStyles();
    var active = props.active,
      completed = props.completed,
      iconos = props.iconos;
    var icons = iconos;
    return /*#__PURE__*/React.createElement("div", {
      className: clsx(classes.root, (_clsx = {}, _clsx[classes.active] = active, _clsx[classes.completed] = completed, _clsx))
    }, icons[String(props.icon)]);
  }
  function ButtonDegrade(props) {
    var _clsx2;
    var classes = useColorlibStepIconStyles();
    var active = props.active,
      completed = props.completed,
      texto = props.texto,
      iconos = props.iconos;
    var icons = iconos;
    return /*#__PURE__*/React.createElement(Fab, {
      variant: "extended",
      className: clsx(classes.rootButton, (_clsx2 = {}, _clsx2[classes.active] = active, _clsx2[classes.completed] = completed, _clsx2))
    }, icons[String(props.icon)], texto);
  }
  var useStyles = makeStyles(function (theme) {
    return {
      root: {
        width: '100%'
      },
      button: {
        marginRight: theme.spacing(1)
      },
      instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
      },
      desktop: {}
    };
  });
  var theme = createMuiTheme({
    overrides: {
      MuiStepper: {
        root: {
          background: 'none'
        }
      }
    }
  });
  var classes = useStyles();
  function getSteps(texts) {
    return texts;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Stepper, {
    alternativeLabel: true,
    activeStep: activeStep,
    connector: /*#__PURE__*/React.createElement(ColorlibConnector, null)
  }, altoPerfil && steps.map(function (label, key) {
    return /*#__PURE__*/React.createElement(Step, {
      key: label.texto
    }, /*#__PURE__*/React.createElement(StepLabel, {
      StepIconComponent: function StepIconComponent(props) {
        return ColorlibStepIcon(_extends({}, props, {
          iconos: iconos
        }));
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      paragraph: true,
      style: {
        fontSize: '1.5vmin',
        wordWrap: 'break-word',
        whiteSpace: 'nowrap'
      }
    }, label.texto.toUpperCase()), /*#__PURE__*/React.createElement(Typography, {
      paragraph: true,
      style: {
        fontSize: '1.3vmin',
        marginTop: '-18px'
      }
    }, "PASO ", key + 1)));
  }), !altoPerfil && steps.map(function (row, index) {
    return /*#__PURE__*/React.createElement(Step, {
      key: index + 3
    }, /*#__PURE__*/React.createElement(StepLabel, {
      key: index + 1,
      id: "steppermovil",
      style: {
        display: matches === true ? 'none' : true
      },
      StepIconComponent: function StepIconComponent(props) {
        return ColorlibStepIcon(_extends({}, props, {
          iconos: iconos
        }));
      }
    }), /*#__PURE__*/React.createElement(StepLabel, {
      key: index + 2,
      id: "stepperdesktop",
      style: {
        display: matches === true & !movil ? true : 'none'
      },
      StepIconComponent: function StepIconComponent(props) {
        return ButtonDegrade(_extends({}, props, {
          iconos: iconos,
          texto: row.texto
        }));
      }
    }), /*#__PURE__*/React.createElement(StepLabel, {
      key: index + 3,
      id: "steppermovil",
      style: {
        display: matches === true & movil ? true : 'none'
      },
      StepIconComponent: function StepIconComponent(props) {
        return ColorlibStepIcon(_extends({}, props, {
          iconos: iconos
        }));
      }
    }));
  }))));
}
var _templateObject$6, _templateObject2$6, _templateObject3$6;
function Oferta(inProps) {
  var props = useThemeProps({
    props: inProps,
    name: 'MFOferta'
  });
  var _props$datos = props.datos,
    datos = _props$datos === void 0 ? [{
      icono: ArrowForwardIcon,
      titulo: 'Monto:',
      texto: "1000",
      iconoLeft: ErrorOutline
    }, {
      icono: AttachMoney,
      titulo: 'Pago:',
      texto: "quincenal "
    }, {
      icono: AttachMoney,
      titulo: 'Pago:',
      texto: "quincenal",
      iconoLeft: ErrorOutline
    }, {
      icono: AttachMoney,
      titulo: 'Pago:',
      texto: "quincenal"
    }, {
      icono: AttachMoney,
      titulo: 'Pago:',
      texto: "quincenal",
      iconoLeft: ErrorOutline
    }] : _props$datos,
    _props$size = props.size,
    size = _props$size === void 0 ? 20 : _props$size,
    _props$color = props.color,
    color = _props$color === void 0 ? 'white' : _props$color,
    _props$colordivider = props.colordivider,
    colordivider = _props$colordivider === void 0 ? 'white' : _props$colordivider,
    _props$colorIcono = props.colorIcono,
    colorIcono = _props$colorIcono === void 0 ? 'white' : _props$colorIcono,
    _props$anchoOferta = props.anchoOferta,
    anchoOferta = _props$anchoOferta === void 0 ? 320 : _props$anchoOferta,
    _props$id = props.id,
    id = _props$id === void 0 ? 'oferta' : _props$id,
    _props$alignrow = props.alignrow,
    alignrow = _props$alignrow === void 0 ? 'none' : _props$alignrow,
    _props$tipografia = props.tipografia,
    tipografia = _props$tipografia === void 0 ? 'courier' : _props$tipografia,
    _props$colorOne = props.colorOne,
    colorOne = _props$colorOne === void 0 ? '#fff' : _props$colorOne,
    _props$colorTwo = props.colorTwo,
    colorTwo = _props$colorTwo === void 0 ? '#000' : _props$colorTwo;
  var _useTheme = useTheme(),
    palette = _useTheme.palette;
  var root = css(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteralLoose(["\n    color: white;\n    background: linear-gradient(\n      133deg,\n      ", " 4%,\n      ", " 128%\n    );\n    border-radius: 40px 0px 40px 0px;\n    color: ", ";\n    font-size: ", "px;\n    ", "\n    position: relative;\n    width: ", "px;\n    max-width: 100%;\n    min-width: 100%;\n    top: 0;\n    bottom: 0;\n  "])), colorOne || palette.secondary.light, colorTwo || palette.secondary.light, color, size, tipografia && 'font-family:' + tipografia + ';', anchoOferta);
  var li = css(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteralLoose(["\n    margin: 0px 0px 0px 5px;\n    max-height: auto;\n    padding-bottom: 6px !important;\n    padding-top: 9px !important;\n    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n    font-weight: 500;\n    text-align: ", ";\n  "])), alignrow);
  var config = css(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteralLoose(["\n    padding: 0px 0px 0px 10px;\n  "])));
  return jsx("div", {
    css: root
  }, jsx(List, {
    component: "ul",
    "aria-label": "main mailbox folders",
    id: id + "-ul"
  }, datos.map(function (row, index) {
    var LeftIcon = row.iconoLeft;
    var Icon = row.icono;
    return jsx(Fragment$1, null, jsx(ListItem, {
      key: index,
      css: li
    }, jsx(ThemeProvider, {
      css: config
    }, jsx(Grid, {
      container: true,
      alignItems: "center",
      alignContent: "center"
    }, jsx(Grid, {
      item: true,
      xs: 1
    }, jsx(Icon, {
      color: colorIcono
    })), jsx(Grid, {
      item: true,
      xs: row.iconoLeft ? 9 : 11
    }, jsx(Typography, {
      style: {
        paddingLeft: '5px',
        fontSize: row.sizeFontLi
      },
      variant: "h5",
      component: "h6"
    }, row.titulo, jsx("strong", null, " ", row.texto))), row.iconoLeft && jsx(Grid, {
      item: true,
      xs: 1
    }, jsx("span", {
      style: {
        textAlign: 'right'
      }
    }, jsx(LeftIcon, {
      color: colorIcono
    })))))), index + 1 < datos.length && jsx(Divider, {
      style: {
        border: 'solid 1px',
        color: colordivider
      }
    }));
  })));
}
Oferta.propTypes = {
  datos: propTypes.array,
  size: propTypes.number,
  tipografia: propTypes.string,
  color: propTypes.string,
  colordivider: propTypes.string,
  colorIcono: propTypes.string,
  anchoOferta: propTypes.number,
  colorOne: propTypes.string,
  colorTwo: propTypes.string,
  id: propTypes.string,
  alignrow: propTypes.string
};
var _extends_1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    module.exports["default"] = module.exports, module.exports.__esModule = true;
    return _extends.apply(this, arguments);
  }
  module.exports = _extends;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(_extends_1);
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */ && prop.charCodeAt(1) === 110
  /* n */ && prop.charCodeAt(2) < 91;
}
/* Z+1 */);

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if (
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false ||
  // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;
    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
      current = current.next;
    } while (current !== undefined);
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
    i = 0,
    len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array

  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.

  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};
var processStyleName = /* #__PURE__ */memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }
  return value;
};
if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};
  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }
    var processed = oldProcessStyleValue(key, value);
    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }
    return processed;
  };
}
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }
  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
    }
    return interpolation;
  }
  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }
    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }
        if (interpolation.styles !== undefined) {
          var next = interpolation.next;
          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }
          var styles = interpolation.styles + ";";
          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }
          return styles;
        }
        return createStringFromObject(mergedProps, registered, interpolation);
      }
    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }
        break;
      }
    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });
        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }
      break;
  } // finalize string values (regular strings and functions interpolated into css calls)

  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = '';
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
        }
        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }
            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }
                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;
if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list

var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }
  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];
  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }
    styles += strings[0];
  } // we start at 1 since we've already handled the first arg

  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }
      styles += strings[i];
    }
  }
  var sourceMap;
  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time

  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' +
    // $FlowFixMe we know it's not null
    match[1];
  }
  var name = murmur2(styles) + identifierName;
  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }
  return {
    name: name,
    styles: styles,
    next: cursor
  };
};
var testOmitPropsOnStringTag = isPropValid;
var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' &&
  // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;
  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }
  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }
  return shouldForwardProp;
};
var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var createStyled = function createStyled(tag, options) {
  if (process.env.NODE_ENV !== 'production') {
    if (tag === undefined) {
      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
    }
  }
  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;
  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }
  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }
    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (process.env.NODE_ENV !== 'production' && args[0][0] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }
      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;
      for (; i < len; i++) {
        if (process.env.NODE_ENV !== 'production' && args[0][i] === undefined) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
        }
        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class

    var Styled = withEmotionCache(function (props, cache, ref) {
      var finalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;
      if (props.theme == null) {
        mergedProps = {};
        for (var key in props) {
          mergedProps[key] = props[key];
        }
        mergedProps.theme = useContext(ThemeContext);
      }
      if (typeof props.className === 'string') {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }
      var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
      var rules = insertStyles(cache, serialized, typeof finalTag === 'string');
      className += cache.key + "-" + serialized.name;
      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }
      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
      var newProps = {};
      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;
        if (
        // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }
      newProps.className = className;
      newProps.ref = ref;
      var ele = /*#__PURE__*/createElement(finalTag, newProps);
      return ele;
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && process.env.NODE_ENV !== 'production') {
          return 'NO_COMPONENT_SELECTOR';
        } // $FlowFixMe: coerce undefined to string

        return "." + targetClassName;
      }
    });
    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, _extends$1({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };
    return Styled;
  };
};
var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
var newStyled = createStyled.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});
var _templateObject$7, _templateObject2$7, _templateObject3$7;
var fullWidth = "\n  width: 100vw;\n  max-width: 100vw;\n";
var flexColumnCentered = "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n";
var Wrapper = newStyled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"])), flexColumnCentered, fullWidth);
var HeaderBackground = newStyled.header(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  border-top-left-radius: 2rem;\n  border-top-right-radius: 2rem;\n  padding-top: 2.5rem;\n  background-color: white;\n"])), flexColumnCentered, fullWidth);
var ImageContainer = newStyled.div(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteralLoose(["\n  ", "\n  z-index: 10;\n  &:first-of-type {\n    margin-bottom: -2.5rem;\n    width: 5rem;\n    height: 5rem;\n  }\n"])), flexColumnCentered);
function Header(_ref) {
  var image = _ref.image,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Wrapper, null, image ? /*#__PURE__*/React.createElement(ImageContainer, null, image) : null, /*#__PURE__*/React.createElement(HeaderBackground, null, children));
}
function RadioButtonsGroup(_ref) {
  var withOptionButton = _ref.withOptionButton,
    colorButton = _ref.colorButton,
    periodo = _ref.periodo,
    periodicidad = _ref.periodicidad,
    eventoCheck = _ref.eventoCheck;
  var _React$useState = React.useState(''),
    value = _React$useState[0],
    setValue = _React$useState[1];
  var handleChange = function handleChange(event, buttonData) {
    if (buttonData === void 0) {
      buttonData = null;
    }
    var chain = event.target.value || buttonData;
    var parts = chain.split(' ');
    setValue(chain);
    var data = {
      value: chain,
      extra: {
        plazo: parts[0],
        periodo: periodicidad,
        periodicidad: parts[1],
        label: chain
      }
    };
    eventoCheck(JSON.stringify(data));
  };
  return /*#__PURE__*/React.createElement("div", null, withOptionButton ? /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, periodo === null || periodo === void 0 ? void 0 : periodo.map(function (row, idx) {
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4,
      md: 3,
      key: idx
    }, /*#__PURE__*/React.createElement(Button, {
      style: {
        background: "" + colorButton,
        padding: '5px 30px 5px 30px'
      },
      onClick: function onClick(e) {
        return handleChange(e, row.label);
      }
    }, parseInt(row.label)));
  })) : /*#__PURE__*/React.createElement(FormControl$1, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    "aria-label": "gender",
    name: "gender1",
    value: value,
    onChange: handleChange
  }, periodo === null || periodo === void 0 ? void 0 : periodo.map(function (row) {
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      key: row.label,
      value: row.label,
      control: /*#__PURE__*/React.createElement(Radio, {
        className: "radioboton"
      }),
      label: row.label
    });
  }))));
}
RadioButtonsGroup.defaultProps = {
  withOptionButton: false,
  colorButton: '#23DFED'
};
var _templateObject$8, _templateObject2$8, _templateObject3$8;
var _excluded$2 = ["altoPerfil", "colorBackgroundHeader", "children", "gutterBottom", "fullWidth", "noPadding", "noHover"];
function CardElevation(_ref) {
  var altoPerfil = _ref.altoPerfil,
    colorBackgroundHeader = _ref.colorBackgroundHeader,
    children = _ref.children,
    gutterBottom = _ref.gutterBottom,
    fullWidth = _ref.fullWidth,
    noPadding = _ref.noPadding,
    noHover = _ref.noHover,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  var fwPaddTop = gutterBottom ? '1.2rem' : '0.1rem';
  var styleObj = {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: fwPaddTop,
      backgroundColor: 'white',
      overflow: 'hidden',
      borderRadius: '24px',
      boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.3)'
    }
  };
  if (!noHover) {
    styleObj = _extends({}, styleObj, {
      root: _extends({}, styleObj.root, {
        '&:hover': {
          boxShadow: '0 16px 70px -12.125px rgba(0,0,0,0.3)'
        }
      })
    });
  }
  var useStyles = makeStyles(styleObj);
  var classes = useStyles();
  var fwContent = css(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteralLoose(["\n    ", ";\n  "])), fullWidth ? "width: 100%;" : '');
  var fwContentPadding = css(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteralLoose(["\n    ", ";\n  "])), noPadding ? "padding: 0px   0px 0px 0px !important;" : '');
  var fwcStyle = css(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n  "])), fwContent, fwContentPadding);
  return jsx(Card, _extends({
    classes: {
      root: classes.root
    }
  }, otherProps), altoPerfil && jsx("div", {
    style: {
      backgroundColor: "" + colorBackgroundHeader,
      height: '130px',
      width: '100%',
      borderRadius: '24px'
    }
  }), jsx(CardContent, {
    css: fwcStyle
  }, children));
}
CardElevation.propTypes = {
  children: propTypes.node.isRequired,
  gutterBottom: propTypes.bool,
  fullWidth: propTypes.bool,
  noPadding: propTypes.bool,
  altoPerfil: propTypes.bool,
  colorBackgroundHeader: propTypes.string,
  noHover: propTypes.bool
};
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      '& > *': {
        margin: theme.spacing(1),
        'border-radius': '40px 40px 40px 40px'
      }
    },
    espacio: {
      padding: '12px 12px 12px 12px',
      margin: '12px 12px 12px 12px'
    },
    contenedor: {
      padding: '50px 10px 50px 10px',
      'text-align': 'center'
    }
  };
});
function ContainedButtons(_ref) {
  var props = _ref.props,
    handleClickFP = _ref.handleClickFP,
    withOptionButton = _ref.withOptionButton,
    colorButton = _ref.colorButton;
  var colorEmpresa = props.colorEmpresa,
    arraySemanas = props.arraySemanas,
    arrayQuincenas = props.arrayQuincenas,
    arrayMeses = props.arrayMeses,
    arrayDefault = props.arrayDefault,
    colorDefault = props.colorDefault,
    labelSemanal = props.labelSemanal,
    labelQuincenal = props.labelQuincenal,
    labelMensual = props.labelMensual;
  var _useState = useState(arrayDefault),
    periodo = _useState[0],
    setPeriodo = _useState[1];
  var _useState2 = useState(colorDefault === labelSemanal ? colorEmpresa : ''),
    colorSemanal = _useState2[0],
    setColorSemanal = _useState2[1];
  var _useState3 = useState(colorDefault === labelQuincenal ? colorEmpresa : ''),
    colorQuincenal = _useState3[0],
    setColorQuincenal = _useState3[1];
  var _useState4 = useState(colorDefault === labelMensual ? colorEmpresa : ''),
    colorMensual = _useState4[0],
    setColorMensual = _useState4[1];
  var _useState5 = useState(colorDefault),
    periodicidadextra = _useState5[0],
    setperiodicidadextra = _useState5[1];
  var classes = useStyles();
  var handleClick = function handleClick(event) {
    var nombre = event;
    if (nombre === labelSemanal) {
      setColorSemanal(colorEmpresa);
      setColorQuincenal('');
      setColorMensual('');
      setPeriodo(arraySemanas);
      setperiodicidadextra(labelSemanal);
    }
    if (nombre === labelQuincenal) {
      setColorSemanal('');
      setColorQuincenal(colorEmpresa);
      setColorMensual('');
      setPeriodo(arrayQuincenas);
      setperiodicidadextra(labelQuincenal);
    }
    if (nombre === labelMensual) {
      setColorSemanal('');
      setColorQuincenal('');
      setColorMensual(colorEmpresa);
      setPeriodo(arrayMeses);
      setperiodicidadextra(labelMensual);
    }
  };
  var handleClickCheck = function handleClickCheck(event) {
    handleClickFP(event);
  };
  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement("div", {
    className: withOptionButton && classes.contenedor
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, Array.isArray(arraySemanas) && /*#__PURE__*/React.createElement(Button$1, {
    id: "semanal",
    key: "semanal",
    style: {
      fontSize: '12px',
      backgroundColor: colorSemanal,
      color: 'white',
      padding: withOptionButton && '5px 40px 5px 40px',
      borderRadius: withOptionButton && '15px',
      marginBottom: withOptionButton && '15px'
    },
    variant: "contained",
    onClick: function onClick() {
      return handleClick(labelSemanal);
    },
    name: "semanal"
  }, labelSemanal), Array.isArray(arrayQuincenas) && /*#__PURE__*/React.createElement(Button$1, {
    id: "quincenal",
    key: "quincenal",
    style: {
      fontSize: '12px',
      backgroundColor: colorQuincenal,
      color: 'white',
      padding: withOptionButton && '5px 40px 5px 40px',
      borderRadius: withOptionButton && '15px',
      marginBottom: withOptionButton && '15px'
    },
    variant: "contained",
    onClick: function onClick() {
      return handleClick(labelQuincenal);
    },
    name: "quincenal"
  }, labelQuincenal), Array.isArray(arrayMeses) && /*#__PURE__*/React.createElement(Button$1, {
    id: "mensual",
    key: "mensual",
    style: {
      fontSize: '12px',
      backgroundColor: colorMensual,
      color: 'white',
      padding: withOptionButton && '5px 40px 5px 40px',
      borderRadius: withOptionButton && '15px',
      marginBottom: withOptionButton && '15px'
    },
    variant: "contained",
    onClick: function onClick() {
      return handleClick(labelMensual);
    },
    name: "mensual"
  }, labelMensual), !withOptionButton && /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.espacio
  }, Array.isArray(periodo) && /*#__PURE__*/React.createElement(RadioButtonsGroup, {
    withOptionButton: withOptionButton,
    colorButton: colorButton,
    periodo: periodo,
    periodicidad: periodicidadextra,
    eventoCheck: handleClickCheck
  }))));
}
function AlertDialog(props) {
  var modalbandera = props.modalbandera,
    content = props.content,
    removeDialog = props.removeDialog;
  var _React$useState = React.useState(modalbandera),
    open = _React$useState[0],
    setOpen = _React$useState[1];
  useEffect(function () {
    setOpen(modalbandera);
  }, [modalbandera]);
  return /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    id: "dialogo"
  }, removeDialog ? content : /*#__PURE__*/React.createElement(DialogContent, null, content));
}
var useStyles$1 = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      minWidth: 295
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    },
    disabled: {
      disabled: true
    }
  };
});
var SimpleSelect = function SimpleSelect(inProps) {
  var props = useThemeProps({
    props: inProps,
    name: 'MFFormaPago'
  });
  var withOptionButton = props.withOptionButton,
    colorLabelTitle = props.colorLabelTitle,
    removeDialog = props.removeDialog,
    colorButton = props.colorButton,
    configuration = props.configuration,
    onClick = props.onClick,
    disabled = props.disabled,
    id = props.id,
    formaPago = props.formaPago,
    cf = props.cf;
  var _useTheme = useTheme(),
    palette = _useTheme.palette;
  var tituloSelect = configuration.tituloSelect,
    arraySemanas = configuration.arraySemanas,
    arrayQuincenas = configuration.arrayQuincenas,
    arrayMeses = configuration.arrayMeses,
    arrayDefault = configuration.arrayDefault,
    colorDefault = configuration.colorDefault,
    labelSemanal = configuration.labelSemanal,
    labelQuincenal = configuration.labelQuincenal,
    labelMensual = configuration.labelMensual;
  var classes = useStyles$1();
  var _React$useState = React.useState(formaPago !== undefined ? formaPago : ''),
    age = _React$useState[0],
    setAge = _React$useState[1];
  var _React$useState2 = React.useState(false),
    modalb = _React$useState2[0],
    setmodalb = _React$useState2[1];
  var _React$useState3 = React.useState(formaPago !== undefined ? formaPago : ''),
    opcion = _React$useState3[0],
    setOpcion = _React$useState3[1];
  var parametros = {
    colorEmpresa: "" + (colorLabelTitle || palette.primary.main),
    arraySemanas: arraySemanas,
    arrayQuincenas: arrayQuincenas,
    arrayMeses: arrayMeses,
    arrayDefault: arrayDefault,
    colorDefault: colorDefault,
    labelSemanal: labelSemanal,
    labelQuincenal: labelQuincenal,
    labelMensual: labelMensual
  };
  var handleChange = function handleChange() {
    if (!disabled) {
      setmodalb(!modalb);
    }
  };
  React.useEffect(function () {
    if (formaPago !== undefined) {
      setOpcion(formaPago);
      setAge(formaPago);
      var chain = formaPago;
      var parts = chain.split(' ');
      onClick(JSON.stringify({
        value: chain,
        extra: {
          plazo: parts[0],
          periodo: cf,
          periodicidad: parts[1],
          label: chain
        }
      }));
    }
  }, [formaPago]);
  var handleClickFP = function handleClickFP(data) {
    var dataJson = JSON.parse(data);
    setOpcion(dataJson.value);
    setAge(dataJson.value);
    onClick(data);
    setmodalb(false);
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormControl$1, {
    variant: "outlined",
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(InputLabel$1, {
    id: "demo-simple-select-outlined-label"
  }, tituloSelect), /*#__PURE__*/React.createElement(Select$2, {
    labelId: "demo-simple-select-outlined-label",
    id: id + "-select",
    value: age,
    label: tituloSelect,
    open: false,
    onClick: handleChange,
    disabled: disabled
  }, /*#__PURE__*/React.createElement("option", {
    id: "opcion",
    value: opcion
  }, opcion))), /*#__PURE__*/React.createElement(AlertDialog, {
    removeDialog: removeDialog,
    modalbandera: modalb,
    content: /*#__PURE__*/React.createElement(ContainedButtons, {
      withOptionButton: withOptionButton,
      colorButton: colorButton,
      props: parametros,
      handleClickFP: handleClickFP
    })
  }));
};
var _templateObject$9, _templateObject2$9;
function Encuesta(inProps) {
  var props = useThemeProps({
    props: inProps,
    name: 'MFEncuesta'
  });
  var idBtnSalir = props.idBtnSalir,
    idBtnEnviar = props.idBtnEnviar,
    eventoenvia = props.eventoenvia,
    eventosalir = props.eventosalir,
    _props$textpoll = props.textpoll,
    textpoll = _props$textpoll === void 0 ? {
      botonuno: 'SALIR SIN ENVIAR',
      botondos: 'ENVIAR',
      referenciauno: 'Nada probable',
      referenciados: 'Muy probable'
    } : _props$textpoll,
    tipografia = props.tipografia,
    size = props.size,
    idBtnCero = props.idBtnCero,
    idBtnOne = props.idBtnOne,
    idBtnTwo = props.idBtnTwo,
    idBtnThree = props.idBtnThree,
    idBtnFour = props.idBtnFour,
    idBtnFive = props.idBtnFive,
    idBtnSix = props.idBtnSix,
    idBtnSeven = props.idBtnSeven,
    idBtnHeight = props.idBtnHeight,
    idBtnNine = props.idBtnNine,
    idBtnTen = props.idBtnTen;
  var botonuno = textpoll.botonuno,
    botondos = textpoll.botondos,
    referenciauno = textpoll.referenciauno,
    referenciados = textpoll.referenciados,
    leyenda = textpoll.leyenda;
  var _useTheme = useTheme(),
    palette = _useTheme.palette;
  var _useState = useState(''),
    calificacion = _useState[0],
    setcalificacion = _useState[1];
  var _useState2 = useState(true),
    btnDisabled = _useState2[0],
    setbtnDisabled = _useState2[1];
  var _useState3 = useState("" + palette.success.main),
    color = _useState3[0];
  var _useState4 = useState("" + palette.success.main),
    colorcero = _useState4[0],
    setcolorcero = _useState4[1];
  var _useState5 = useState("" + palette.success.main),
    colorone = _useState5[0],
    setcolorone = _useState5[1];
  var _useState6 = useState("" + palette.success.main),
    colortwo = _useState6[0],
    setcolortwo = _useState6[1];
  var _useState7 = useState("" + palette.success.main),
    colorthree = _useState7[0],
    setcolorthree = _useState7[1];
  var _useState8 = useState("" + palette.success.main),
    colorfour = _useState8[0],
    setcolorfour = _useState8[1];
  var _useState9 = useState("" + palette.success.main),
    colorfive = _useState9[0],
    setcolorfive = _useState9[1];
  var _useState10 = useState("" + palette.success.main),
    colorsix = _useState10[0],
    setcolorsix = _useState10[1];
  var _useState11 = useState("" + palette.success.main),
    colorseven = _useState11[0],
    setcolorseven = _useState11[1];
  var _useState12 = useState("" + palette.success.main),
    colorheight = _useState12[0],
    setcolorheight = _useState12[1];
  var _useState13 = useState("" + palette.success.main),
    colornine = _useState13[0],
    setcolornine = _useState13[1];
  var _useState14 = useState("" + palette.success.main),
    colorten = _useState14[0],
    setcolorten = _useState14[1];
  var estilo = css(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteralLoose(["\n    width: 25px;\n    height: 25px;\n    padding: 2px;\n    text-align: center;\n    border-radius: 5px;\n    margin: 0px 1px 0px;\n    background-color: ", ";\n    color: ", ";\n    font-weight: bold;\n  "])), color, palette.white);
  var movildos = css(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteralLoose(["\n    @media only screen and (min-width: 320px) {\n      padding-left: 27%;\n    }\n\n    @media only screen and (min-width: 540px) {\n      padding-left: 18%;\n    }\n\n    @media only screen and (min-width: 768px) {\n      padding-left: 12%;\n    }\n\n    @media only screen and (min-width: 820px) {\n      padding-left: 8%;\n    }\n  "])));
  var useStyles = makeStyles(function (theme) {
    return {
      typography: {
        fontFamily: 'Raleway, Arial'
      },
      hover: {}
    };
  });
  var classes = useStyles();
  var califButton = function califButton(event) {
    if (event === 0) {
      setcolorcero(palette.primary.main);
      setcolorone(palette.success.main);
      setcolortwo(palette.success.main);
      setcolorthree(palette.success.main);
      setcolorfour(palette.success.main);
      setcolorfive(palette.success.main);
      setcolorsix(palette.success.main);
      setcolorseven(palette.success.main);
      setcolorheight(palette.success.main);
      setcolornine(palette.success.main);
      setcolorten(palette.success.main);
    }
    if (event === 1) {
      setcolorcero(palette.success.main);
      setcolorone(palette.primary.main);
      setcolortwo(palette.success.main);
      setcolorthree(palette.success.main);
      setcolorfour(palette.success.main);
      setcolorfive(palette.success.main);
      setcolorsix(palette.success.main);
      setcolorseven(palette.success.main);
      setcolorheight(palette.success.main);
      setcolornine(palette.success.main);
      setcolorten(palette.success.main);
    }
    if (event === 2) {
      setcolorcero(palette.success.main);
      setcolorone(palette.success.main);
      setcolortwo(palette.primary.main);
      setcolorthree(palette.success.main);
      setcolorfour(palette.success.main);
      setcolorfive(palette.success.main);
      setcolorsix(palette.success.main);
      setcolorseven(palette.success.main);
      setcolorheight(palette.success.main);
      setcolornine(palette.success.main);
      setcolorten(palette.success.main);
    }
    if (event === 3) {
      setcolorcero(palette.success.main);
      setcolorone(palette.success.main);
      setcolortwo(palette.success.main);
      setcolorthree(palette.primary.main);
      setcolorfour(palette.success.main);
      setcolorfive(palette.success.main);
      setcolorsix(palette.success.main);
      setcolorseven(palette.success.main);
      setcolorheight(palette.success.main);
      setcolornine(palette.success.main);
      setcolorten(palette.success.main);
    }
    if (event === 4) {
      setcolorcero(palette.success.main);
      setcolorone(palette.success.main);
      setcolortwo(palette.success.main);
      setcolorthree(palette.success.main);
      setcolorfour(palette.primary.main);
      setcolorfive(palette.success.main);
      setcolorsix(palette.success.main);
      setcolorseven(palette.success.main);
      setcolorheight(palette.success.main);
      setcolornine(palette.success.main);
      setcolorten(palette.success.main);
    }
    if (event === 5) {
      setcolorcero(palette.success.main);
      setcolorone(palette.success.main);
      setcolortwo(palette.success.main);
      setcolorthree(palette.success.main);
      setcolorfour(palette.success.main);
      setcolorfive(palette.primary.main);
      setcolorsix(palette.success.main);
      setcolorseven(palette.success.main);
      setcolorheight(palette.success.main);
      setcolornine(palette.success.main);
      setcolorten(palette.success.main);
    }
    if (event === 6) {
      setcolorcero(palette.success.main);
      setcolorone(palette.success.main);
      setcolortwo(palette.success.main);
      setcolorthree(palette.success.main);
      setcolorfour(palette.success.main);
      setcolorfive(palette.success.main);
      setcolorsix(palette.primary.main);
      setcolorseven(palette.success.main);
      setcolorheight(palette.success.main);
      setcolornine(palette.success.main);
      setcolorten(palette.success.main);
    }
    if (event === 7) {
      setcolorcero(palette.success.main);
      setcolorone(palette.success.main);
      setcolortwo(palette.success.main);
      setcolorthree(palette.success.main);
      setcolorfour(palette.success.main);
      setcolorfive(palette.success.main);
      setcolorsix(palette.success.main);
      setcolorseven(palette.primary.main);
      setcolorheight(palette.success.main);
      setcolornine(palette.success.main);
      setcolorten(palette.success.main);
    }
    if (event === 8) {
      setcolorcero(palette.success.main);
      setcolorone(palette.success.main);
      setcolortwo(palette.success.main);
      setcolorthree(palette.success.main);
      setcolorfour(palette.success.main);
      setcolorfive(palette.success.main);
      setcolorsix(palette.success.main);
      setcolorseven(palette.success.main);
      setcolorheight(palette.primary.main);
      setcolornine(palette.success.main);
      setcolorten(palette.success.main);
    }
    if (event === 9) {
      setcolorcero(palette.success.main);
      setcolorone(palette.success.main);
      setcolortwo(palette.success.main);
      setcolorthree(palette.success.main);
      setcolorfour(palette.success.main);
      setcolorfive(palette.success.main);
      setcolorsix(palette.success.main);
      setcolorseven(palette.success.main);
      setcolorheight(palette.success.main);
      setcolornine(palette.primary.main);
      setcolorten(palette.success.main);
    }
    if (event === 10) {
      setcolorcero(palette.success.main);
      setcolorone(palette.success.main);
      setcolortwo(palette.success.main);
      setcolorthree(palette.success.main);
      setcolorfour(palette.success.main);
      setcolorfive(palette.success.main);
      setcolorsix(palette.success.main);
      setcolorseven(palette.success.main);
      setcolorheight(palette.success.main);
      setcolornine(palette.success.main);
      setcolorten(palette.primary.main);
    }
    setcalificacion(event);
    setbtnDisabled(false);
  };
  var enviar = function enviar() {
    eventoenvia(calificacion);
  };
  var cancelar = function cancelar() {
    eventosalir('');
    setbtnDisabled(true);
  };
  return jsx("div", {
    style: {
      width: '100%'
    },
    className: classes.typography
  }, jsx(Typography$1, {
    component: "div"
  }, jsx(Box$1, {
    display: "flex",
    p: 1,
    bgcolor: "background.paper",
    fontSize: size,
    fontStyle: tipografia,
    style: {
      textAlign: 'justify',
      margin: '0px 20px 0px !important'
    }
  }, jsx(Grid$1, {
    container: true,
    spacing: 0
  }, jsx(Grid$1, {
    item: true,
    xs: 12,
    md: 12,
    lg: 12
  }, jsx("p", {
    style: {
      margin: '0px 20px 0px'
    }
  }, leyenda)))), jsx(Grid$1, {
    container: true,
    spacing: 0
  }, jsx(Grid$1, {
    item: true,
    xs: 12,
    md: 12,
    lg: 12
  }, jsx("div", {
    style: {
      margin: '0px 20px 0px'
    }
  }, jsx(Box$1, {
    display: "flex",
    p: 1,
    bgcolor: "background.paper",
    fontSize: size,
    fontStyle: tipografia
  }, idBtnCero && idBtnCero !== '' && jsx("div", {
    id: idBtnCero + "-0-button",
    css: estilo,
    style: {
      opacity: '0.4',
      backgroundColor: colorcero,
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return califButton(0);
    }
  }, "0"), idBtnOne && idBtnOne !== '' && jsx("div", {
    id: idBtnOne + "-1-button",
    css: estilo,
    style: {
      opacity: '0.4',
      backgroundColor: colorone,
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return califButton(1);
    }
  }, "1"), idBtnTwo && idBtnTwo !== '' && jsx("div", {
    id: idBtnTwo + "-2-button",
    css: estilo,
    style: {
      opacity: '0.5',
      backgroundColor: colortwo,
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return califButton(2);
    }
  }, "2"), idBtnThree && idBtnThree !== '' && jsx("div", {
    id: idBtnThree + "-3-button",
    css: estilo,
    style: {
      opacity: '0.5',
      backgroundColor: colorthree,
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return califButton(3);
    }
  }, "3"), idBtnFour && idBtnFour !== '' && jsx("div", {
    id: idBtnFour + "-4-button",
    css: estilo,
    style: {
      opacity: '0.6',
      backgroundColor: colorfour,
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return califButton(4);
    }
  }, "4"), idBtnFive && idBtnFive !== '' && jsx("div", {
    id: idBtnFive + "-5-button",
    css: estilo,
    style: {
      opacity: '0.6',
      backgroundColor: colorfive,
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return califButton(5);
    }
  }, "5"), idBtnSix && idBtnSix !== '' && jsx("div", {
    id: idBtnSix + "-6-button",
    css: estilo,
    style: {
      opacity: '0.7',
      backgroundColor: colorsix,
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return califButton(6);
    }
  }, "6"), idBtnSeven && idBtnSeven !== '' && jsx("div", {
    id: idBtnSeven + "-7-button",
    css: estilo,
    style: {
      opacity: '0.7',
      backgroundColor: colorseven,
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return califButton(7);
    }
  }, "7"), idBtnHeight && idBtnHeight !== '' && jsx("div", {
    id: idBtnHeight + "-8-button",
    css: estilo,
    style: {
      opacity: '0.8',
      backgroundColor: colorheight,
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return califButton(8);
    }
  }, "8"), idBtnNine && idBtnNine !== '' && jsx("div", {
    id: idBtnNine + "-9-button",
    css: estilo,
    style: {
      opacity: '0.9',
      backgroundColor: colornine,
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return califButton(9);
    }
  }, "9"), idBtnTen && idBtnTen !== '' && jsx("div", {
    id: idBtnTen + "-10-button",
    css: estilo,
    style: {
      opacity: '1',
      backgroundColor: colorten,
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return califButton(10);
    }
  }, "10"))))), jsx("div", {
    style: {
      display: 'flex',
      paddingLeft: '30px'
    }
  }, jsx("div", {
    style: {
      width: '150'
    }
  }, jsx("span", {
    style: {
      color: 'rgba(0, 0, 0, 0.5)'
    }
  }, referenciauno)), jsx("div", {
    css: movildos
  }, jsx("span", {
    style: {
      color: 'rgba(0, 0, 0, 0.5)'
    }
  }, referenciados))), jsx(Box$1, {
    display: "flex",
    p: 1,
    bgcolor: "background.paper",
    fontSize: size,
    fontStyle: tipografia
  }, jsx(Grid$1, {
    container: true,
    spacing: 3
  }, jsx(Grid$1, {
    item: true,
    xs: 1,
    md: 9
  }), jsx(Grid$1, {
    item: true,
    xs: 7,
    md: 2
  }, jsx(Button$1, {
    id: idBtnSalir + "-button",
    style: {
      fontWeight: 'bold'
    },
    color: "primary",
    onClick: cancelar,
    disabled: btnDisabled
  }, botonuno)), jsx(Grid$1, {
    item: true,
    xs: 4,
    md: 1
  }, jsx(Button$1, {
    id: idBtnEnviar + "-button",
    style: {
      fontWeight: 'bold'
    },
    color: "primary",
    onClick: enviar,
    disabled: btnDisabled
  }, botondos))))));
}
Encuesta.propTypes = {
  textpoll: propTypes.object,
  eventosalir: propTypes.func,
  eventoenvia: propTypes.func,
  botonuno: propTypes.string,
  botondos: propTypes.string,
  referenciauno: propTypes.string,
  referenciados: propTypes.string,
  leyenda: propTypes.string,
  tipografia: propTypes.string,
  size: propTypes.number,
  idBtnCero: propTypes.string,
  idBtnOne: propTypes.string,
  idBtnTwo: propTypes.string,
  idBtnThree: propTypes.string,
  idBtnFour: propTypes.string,
  idBtnFive: propTypes.string,
  idBtnSix: propTypes.string,
  idBtnSeven: propTypes.string,
  idBtnHeight: propTypes.string,
  idBtnNine: propTypes.string,
  idBtnTen: propTypes.string,
  idBtnSalir: propTypes.string,
  idBtnEnviar: propTypes.string
};
var _templateObject$a, _templateObject2$a, _templateObject3$9, _templateObject4$5, _templateObject5$5, _templateObject6$5, _templateObject7$3;
var TitleIcon = function TitleIcon(inProps) {
  var _palette$iconColor;
  var props = useThemeProps({
    props: inProps,
    name: 'MFTitleIcon'
  });
  var title = props.title,
    _props$icon = props.icon,
    icon = _props$icon === void 0 ? null : _props$icon,
    _props$size = props.size,
    size = _props$size === void 0 ? false : _props$size,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$textColor = props.textColor,
    textColor = _props$textColor === void 0 ? false : _props$textColor,
    _props$iconColor = props.iconColor,
    iconColor = _props$iconColor === void 0 ? 'primary' : _props$iconColor;
  var _useTheme = useTheme(),
    palette = _useTheme.palette;
  var Icon = icon;
  if (!Icon) {
    throw new Error('El icono es necesario');
  }
  var colorDisabled = css(_templateObject$a || (_templateObject$a = _taggedTemplateLiteralLoose(["\n    color: ", ";\n  "])), palette.text.disabled);
  var iconColorCss = css(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteralLoose(["\n    ", "\n  "])), disabled ? colorDisabled : "color: " + ((palette === null || palette === void 0 ? void 0 : (_palette$iconColor = palette[iconColor]) === null || _palette$iconColor === void 0 ? void 0 : _palette$iconColor.main) || iconColor));
  var h1Color = css(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteralLoose(["\n    ", ";\n  "])), disabled ? colorDisabled : textColor ? "color: " + palette.primary.main : '');
  var root = css(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n  "])));
  var fontSize = css(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteralLoose(["\n    font-size: ", "px !important;\n  "])), size);
  var h1Style = css(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n  "])), h1Color, fontSize);
  var iconStyle = css(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteralLoose(["\n    ", "\n    margin-right: 0.3em;\n    ", "\n  "])), fontSize, iconColorCss);
  return jsx("div", {
    css: root
  }, jsx(Icon, {
    css: iconStyle
  }), jsx(Typography, {
    css: h1Style,
    component: "h1"
  }, title));
};
TitleIcon.propTypes = {
  icon: propTypes.object.isRequired,
  title: propTypes.string.isRequired,
  size: propTypes.number,
  disabled: propTypes.bool,
  textColor: propTypes.bool,
  iconColor: propTypes.string
};
var _templateObject$b, _templateObject2$b;
var Referencia = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Referencia, _Component);
  function Referencia(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.root = css(_templateObject$b || (_templateObject$b = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center !important;\n  "])));
    _this.mb1 = css(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteralLoose(["\n    margin-bottom: 1rem !important;\n  "])));
    _this.handleInput = function (e) {
      var item = e.target.name;
      var value = e.target.value;
      if (item !== 'tel' && item !== 'relation') {
        var maxLength = 20;
        var pattern = /^[ñA-Za-z ]*$/;
        var error = RegExp(pattern, 'i').test(value);
        if (error && value.length < maxLength) {
          var _extends2;
          _this.setState({
            data: _extends({}, _this.state.data, (_extends2 = {}, _extends2[item] = value, _extends2))
          }, function () {
            _this.props.onChange(_this.state.data);
            e.target.focus();
          });
          e.target.focus();
        }
      } else {
        if (item === 'tel') {
          var _maxLength = 11;
          var _pattern = /^[0-9]*$/;
          var _error = RegExp(_pattern, 'i').test(value);
          if (_error && value.length < _maxLength) {
            var _extends3;
            _this.setState({
              data: _extends({}, _this.state.data, (_extends3 = {}, _extends3[item] = value, _extends3))
            }, function () {
              _this.props.onChange(_this.state.data);
              e.target.focus();
            });
            e.target.focus();
          }
        } else {
          var _extends4;
          _this.setState({
            data: _extends({}, _this.state.data, (_extends4 = {}, _extends4[item] = value, _extends4))
          }, function () {
            _this.props.onChange(_this.state.data);
          });
        }
      }
    };
    _this.state = {
      data: {
        name: '',
        app: '',
        apm: '',
        tel: '',
        relation: ''
      },
      error: true
    };
    return _this;
  }
  var _proto = Referencia.prototype;
  _proto.render = function render() {
    var _this2 = this;
    return jsx(CardElevation, {
      elevation: "450px"
    }, jsx("div", {
      css: this.root
    }, jsx("div", {
      css: this.mb1
    }, jsx(TitleIcon, {
      icon: PersonIcon,
      title: this.props.title
    })), jsx(TextField, {
      css: this.mb1,
      id: "name",
      label: "Nombre(s)",
      disabled: this.props.disabled,
      helperText: "Ingresa tu nombre o nombres",
      variant: "outlined",
      name: "name",
      onChange: function onChange(e) {
        return _this2.handleInput(e);
      },
      value: this.state.data.name
    }), jsx(TextField, {
      css: this.mb1,
      id: "app",
      label: "Apellido Paterno",
      disabled: this.props.disabled,
      helperText: "Ingresa tu apellido paterno",
      variant: "outlined",
      name: "app",
      onChange: function onChange(e) {
        return _this2.handleInput(e);
      },
      value: this.state.data.app
    }), jsx(TextField, {
      css: this.mb1,
      id: "apm",
      label: "Apellido Materno",
      disabled: this.props.disabled,
      helperText: "Ingresa tu apellido materno",
      variant: "outlined",
      name: "apm",
      onChange: function onChange(e) {
        return _this2.handleInput(e);
      },
      value: this.state.data.apm
    }), jsx(TextField, {
      css: this.mb1,
      id: "tel",
      label: "Tel\xE9fono",
      disabled: this.props.disabled,
      helperText: "Ingresa un n\xFAmero activo",
      variant: "outlined",
      name: "tel",
      onChange: function onChange(e) {
        return _this2.handleInput(e);
      },
      value: this.state.data.tel
    }), jsx(FormControl, {
      variant: "outlined"
    }, jsx(InputLabel, {
      htmlFor: "outlined-age-native-simple"
    }, "Relaci\xF3n"), jsx(Select$1, {
      id: "relation",
      color: "primary",
      disabled: this.props.disabled,
      "native": true,
      label: "relation",
      name: "relation",
      onChange: function onChange(e) {
        return _this2.handleInput(e);
      },
      value: this.state.data.relation
    }, jsx("option", {
      "aria-label": "None",
      value: ""
    }), jsx("option", {
      key: "1",
      value: "45"
    }, "uno")))));
  };
  return Referencia;
}(Component);
Referencia.propTypes = {
  title: propTypes.string,
  onChange: propTypes.func.isRequired,
  disabled: propTypes.bool
};
Referencia.defaultProps = {
  title: 'Referencia',
  disabled: false
};
var _templateObject$c, _templateObject2$c, _templateObject3$a, _templateObject4$6, _templateObject5$6, _templateObject6$6, _templateObject7$4, _templateObject8$2, _templateObject9$1, _templateObject10$1, _templateObject11, _templateObject12, _templateObject13;
var _excluded$3 = ["label", "viewListFiles", "btnRightModal", "selectedFiles", "titleOneFileUpload", "titleSeveralFileUpload", "accept", "required", "helpPlacement", "onChange", "disabled", "fileNameString", "multiple", "id", "loadingSize", "loadingColor", "loading", "icon", "help", "helperText", "fullWidth", "openModal", "setOpenModal", "value", "iconButton", "showIcon", "componentProps"];
function FileUpload(inProps) {
  var props = useThemeProps({
    props: inProps,
    name: 'MFFileUpload'
  });
  var label = props.label,
    _props$viewListFiles = props.viewListFiles,
    viewListFiles = _props$viewListFiles === void 0 ? 'Ver lista de archivos' : _props$viewListFiles,
    _props$btnRightModal = props.btnRightModal,
    btnRightModal = _props$btnRightModal === void 0 ? 'Cerrar' : _props$btnRightModal,
    _props$selectedFiles = props.selectedFiles,
    selectedFiles = _props$selectedFiles === void 0 ? 'archivos seleccionados' : _props$selectedFiles,
    _props$titleOneFileUp = props.titleOneFileUpload,
    titleOneFileUpload = _props$titleOneFileUp === void 0 ? 'Archivo seleccionado' : _props$titleOneFileUp,
    _props$titleSeveralFi = props.titleSeveralFileUpload,
    titleSeveralFileUpload = _props$titleSeveralFi === void 0 ? 'Archivos seleccionados' : _props$titleSeveralFi,
    _props$accept = props.accept,
    accept = _props$accept === void 0 ? 'image/*, application/pdf, application/octet-stream' : _props$accept,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    _props$helpPlacement = props.helpPlacement,
    helpPlacement = _props$helpPlacement === void 0 ? 'left' : _props$helpPlacement,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$fileNameString = props.fileNameString,
    fileNameString = _props$fileNameString === void 0 ? '' : _props$fileNameString,
    multiple = props.multiple,
    _props$id = props.id,
    id = _props$id === void 0 ? 'file-upload' : _props$id,
    _props$loadingSize = props.loadingSize,
    loadingSize = _props$loadingSize === void 0 ? 20 : _props$loadingSize,
    _props$loadingColor = props.loadingColor,
    loadingColor = _props$loadingColor === void 0 ? 'primary' : _props$loadingColor,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    icon = props.icon,
    help = props.help,
    helperText = props.helperText,
    fullWidth = props.fullWidth,
    openModal = props.openModal,
    setOpenModal = props.setOpenModal,
    value = props.value,
    _props$iconButton = props.iconButton,
    iconButton = _props$iconButton === void 0 ? jsx(Publish, null) : _props$iconButton,
    _props$showIcon = props.showIcon,
    showIcon = _props$showIcon === void 0 ? true : _props$showIcon,
    _props$componentProps = props.componentProps,
    componentProps = _props$componentProps === void 0 ? {} : _props$componentProps,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$3);
  var Icon = icon;
  var _useTheme = useTheme(),
    palette = _useTheme.palette;
  var isControlled = Boolean(value);
  var _useState = useState(''),
    fileName = _useState[0],
    setFileName = _useState[1];
  var _useState2 = useState(false),
    open = _useState2[0],
    setOpen = _useState2[1];
  var fileInputRef = createRef();
  var _useState3 = useState([]),
    fileArray = _useState3[0],
    setFiles = _useState3[1];
  var _useState4 = useState([]),
    title = _useState4[0],
    setTitle = _useState4[1];
  useEffect(function () {
    if (value && value.length > 0) {
      setParams(value);
    }
  }, [value]);
  var useStyles = makeStyles({
    border: {
      borderColor: palette.primary.main
    },
    color: {
      color: fileName || fileNameString ? palette.primary.main : palette.action.disabled
    }
  });
  var classes = useStyles();
  var color = css(_templateObject$c || (_templateObject$c = _taggedTemplateLiteralLoose(["\n    color: ", ";\n  "])), fileName || fileNameString ? palette.primary.main : palette.action.disabled);
  var cursor = css(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteralLoose(["\n    cursor: ", ";\n  "])), disabled ? 'not-allowed' : 'pointer');
  var rootDivCss = css(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteralLoose(["\n    ", "\n  "])), fullWidth ? 'width: 100%' : '');
  var root = css(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n  "])));
  var iconItem = css(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteralLoose(["\n    width: 25px;\n    margin-right: 0.5em;\n  "])));
  var tooltip = css(_templateObject6$6 || (_templateObject6$6 = _taggedTemplateLiteralLoose(["\n    margin-left: 0.1em;\n    color: ", ";\n    ", ";\n  "])), palette.action.disabled, cursor);
  var InputFile = newStyled.input(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteralLoose(["\n    opacity: 0;\n    position: absolute;\n    z-index: -1;\n    height: 100%;\n    width: 100%;\n    display: none;\n  "])));
  var textFieldCss = css(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteralLoose(["\n    ", ";\n    & input[type='text'] {\n      ", ";\n    }\n  "])), cursor, cursor);
  var Dynamic = css(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteralLoose(["\n    & * svg {\n      ", "\n      fill: ", ";\n    }\n  "])), cursor, fileName || fileNameString ? palette.primary.main : palette.action.disabled);
  var helper = css(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteralLoose(["\n    padding-left: ", ";\n    padding-top: 0.2em;\n    color: ", ";\n  "])), loading ? '3.5em' : '1em', palette.text.secondary);
  var filesDivCss = css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n    max-height: 30vh;\n    overflow: auto;\n  "])));
  var textArchiveCss = css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n    color: #43ac3a;\n    font-size: 18px;\n  "])));
  var marginTextArchiveCss = css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n    margin-top: 5px;\n  "])));
  var isMultiple = function isMultiple(array) {
    var count = array.length;
    return count > 1;
  };
  var setParams = function setParams(files) {
    var fileArray = Array.from(files);
    var name = getFileName(fileArray);
    var titleModal = getTitle(fileArray);
    setFiles(fileArray);
    setTitle(titleModal);
    setFileName(name);
  };
  var getFileName = function getFileName(files) {
    var filesNumber = files.length;
    var name;
    if (isMultiple(files)) {
      name = filesNumber + " " + selectedFiles + "...";
    } else {
      name = files[0].name;
    }
    return name;
  };
  var getTitle = function getTitle(files) {
    return isMultiple(files) ? titleSeveralFileUpload : titleOneFileUpload;
  };
  var _onChange = function _onChange(fileInput) {
    var files = fileInput.target.files;
    var fileArray = Array.from(files);
    var name = getFileName(fileArray);
    if (!isControlled) {
      setParams(files);
    }
    var data = {
      extra: {
        fileName: name
      }
    };
    if (isMultiple(files) || multiple) {
      data = _extends({}, data, {
        value: files
      });
    } else {
      data = _extends({}, data, {
        value: files[0]
      });
    }
    onChange(data, fileInput);
  };
  var _onClick = function _onClick() {
    if (!disabled) {
      fileInputRef.current.click();
    }
  };
  var FilesDiv = function FilesDiv() {
    return jsx("div", {
      css: filesDivCss
    }, jsx(Grid, {
      container: true,
      direction: "column"
    }, fileArray.map(function (file, index) {
      return jsx(Grid, {
        key: index,
        item: true,
        css: marginTextArchiveCss
      }, jsx("span", {
        css: textArchiveCss
      }, file.name));
    })));
  };
  var handleModal = function handleModal() {
    openModal ? setOpenModal(!openModal) : setOpen(!open);
  };
  return jsx("div", _extends({
    css: rootDivCss
  }, otherProps), jsx(ModalInfo, {
    onClose: function onClose() {
      return handleModal();
    },
    title: title,
    buttonJustify: "flex-end",
    color: "primary",
    open: openModal || open,
    btnLeft: null,
    body: jsx(FilesDiv, null),
    btnRight: btnRightModal,
    btnRightColor: "primary",
    onChange: function onChange(data) {
      return handleModal();
    },
    rootCss: " @media(min-width: 768px){ width: 50%!important; height: auto!import;                             } @media(min-width: 1024px){ width: 40%!important;  height: auto!import;                            } @media(min-width: 1440px){ width: 35%!important;    height: auto!import;                      }"
  }), jsx("div", {
    css: root
  }, loading && jsx("div", {
    css: iconItem
  }, jsx(CircularProgress, {
    color: loadingColor,
    size: loadingSize
  })), showIcon && jsx("div", {
    css: iconItem
  }, Icon && jsx(Icon, {
    css: color
  })), jsx(FormControl, _extends({
    variant: "outlined",
    fullWidth: fullWidth
  }, componentProps.formControl), jsx(TextField, _extends({
    css: textFieldCss,
    variant: "outlined",
    label: label,
    disabled: disabled,
    required: required,
    onClick: _onClick,
    value: fileName || fileNameString,
    id: id + "-input",
    InputProps: {
      readOnly: true,
      classes: {
        notchedOutline: fileName ? classes.border : null
      },
      endAdornment: jsx(InputAdornment, {
        position: "end"
      }, jsx(IconButton, {
        "aria-label": "Carga Archivo",
        edge: "end",
        css: Dynamic
      }, iconButton))
    }
  }, componentProps.textField)), jsx(InputFile, _extends({
    type: "file",
    id: id + "-file-input",
    multiple: multiple,
    ref: fileInputRef,
    onChange: _onChange,
    accept: accept
  }, componentProps.inputFile))), help && jsx(Tooltip, {
    id: id + "-tooltip",
    title: help,
    placement: helpPlacement
  }, jsx(InfoOutlined, {
    id: id + "-tooltip-icon-svg",
    css: tooltip
  })), (fileArray === null || fileArray === void 0 ? void 0 : fileArray.length) > 1 && jsx(Tooltip, {
    title: viewListFiles,
    placement: helpPlacement
  }, jsx(IconButton, {
    css: Dynamic,
    onClick: handleModal
  }, jsx(VisibilityIcon, null)))), helperText && jsx("div", {
    css: root
  }, jsx("div", {
    css: iconItem
  }), jsx(Typography, {
    id: id + "-span",
    variant: "caption",
    css: helper
  }, helperText)));
}
FileUpload.propTypes = {
  viewListFiles: propTypes.string,
  btnRightModal: propTypes.string,
  selectedFiles: propTypes.string,
  titleOneFileUpload: propTypes.string,
  titleSeveralFileUpload: propTypes.string,
  icon: propTypes.object,
  label: propTypes.string,
  title: propTypes.string,
  onChange: propTypes.func,
  accept: propTypes.string,
  help: propTypes.string,
  helpPlacement: propTypes.string,
  disabled: propTypes.bool,
  openModal: propTypes.bool,
  fileNameString: propTypes.string,
  helperText: propTypes.string,
  id: propTypes.string,
  multiple: propTypes.bool,
  fullWidth: propTypes.bool,
  value: propTypes.array,
  iconButton: propTypes.node,
  showIcon: propTypes.bool,
  componentProps: propTypes.object
};
var _excluded$4 = ["expanded", "header", "titulo", "children", "isTimeLine", "showExpandIcon"];
var useStyles$2 = makeStyles(function (theme) {
  return {
    root: {
      width: '100%',
      '& #panel1bh-header': {
        width: '100% !important'
      }
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '33.33%',
      flexShrink: 0
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary
    },
    clearSpace: {
      padding: '0 !important',
      '& .MuiAccordionSummary-content': {
        margin: '0 !important'
      }
    }
  };
});
function SimpleAccordion(_ref) {
  var expanded = _ref.expanded,
    header = _ref.header,
    titulo = _ref.titulo,
    children = _ref.children,
    isTimeLine = _ref.isTimeLine,
    showExpandIcon = _ref.showExpandIcon,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  var classes = useStyles$2();
  var _React$useState = React.useState(expanded ? 'panel1' : ''),
    expandedState = _React$useState[0],
    setExpanded = _React$useState[1];
  var handleChange = function handleChange(panel) {
    return function (event, isExpanded) {
      setExpanded(isExpanded ? panel : false);
    };
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Accordion, _extends({
    expanded: expandedState === 'panel1' || !showExpandIcon,
    onChange: handleChange('panel1')
  }, otherProps), header && /*#__PURE__*/React.createElement(AccordionSummary, {
    className: isTimeLine && classes.clearSpace,
    expandIcon: showExpandIcon && /*#__PURE__*/React.createElement(ExpandMoreIcon, null),
    "aria-controls": "panel1bh-content",
    id: "panel1bh-header"
  }, titulo), /*#__PURE__*/React.createElement(AccordionDetails, {
    className: isTimeLine && classes.clearSpace
  }, children)));
}
SimpleAccordion.defaultProps = {
  expanded: true,
  header: true,
  showExpandIcon: true,
  isTimeLine: false
};
var _templateObject$d, _templateObject2$d, _templateObject3$b, _templateObject4$7, _templateObject5$7, _templateObject6$7, _templateObject7$5, _templateObject8$3, _templateObject9$2;
var CardProgres = function CardProgres(inProps) {
  var props = useThemeProps({
    props: inProps,
    name: 'MFCardProgres'
  });
  var _props$id = props.id,
    id = _props$id === void 0 ? 'card-progreso' : _props$id,
    _props$title = props.title,
    title = _props$title === void 0 ? 'Card Progreso' : _props$title,
    body = props.body,
    _props$textAction = props.textAction,
    textAction = _props$textAction === void 0 ? 'Progreso' : _props$textAction,
    icon = props.icon,
    status = props.status,
    firstItem = props.firstItem,
    lastItem = props.lastItem,
    onChange = props.onChange,
    bgIconColor = props.bgIconColor,
    isExpanded = props.isExpanded,
    children = props.children,
    monocromatico = props.monocromatico;
  var _useTheme = useTheme(),
    palette = _useTheme.palette;
  var stylesTitle = css(_templateObject$d || (_templateObject$d = _taggedTemplateLiteralLoose(["\n    font-size: 16px !important;\n    font-weight: bold !important;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.5 !important;\n    letter-spacing: 0.15px !important;\n    color: ", " !important;\n    margin-bottom: 0.5rem !important;\n    margin-top: 0.5rem !important;\n  "])), monocromatico ? '#282828!important' : palette.primary.main);
  var stylesBody = css(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteralLoose(["\n    font-size: 12px !important;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: ", ";\n    line-height: 1.25 !important;\n    letter-spacing: 0.13px !important;\n    color: ", ";\n    margin-bottom: 1.5rem !important;\n  "])), monocromatico ? 'italic' : 'normal', monocromatico ? '#949494' : '#000000');
  var styleContentIcon = css(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteralLoose(["\n    width: ", " !important;\n    margin-left: ", ";\n    margin-right: ", ";\n    height: ", " !important;\n    background: ", ";\n    border-radius: 100%;\n    color: white;\n    justifycontent: center;\n    align-items: center;\n    z-index: 200;\n  "])), monocromatico ? '30px' : '40px', monocromatico && '5px !important', monocromatico && '5px !important', monocromatico ? '30px' : '40px', monocromatico ? '#bdbdbd' : bgIconColor || (status === 'new' ? palette.action.disabled : status === 'needscorrection' ? palette.warning.main : status === 'error' ? 'linear-gradient(to bottom, #ea0101, #772020)' : status === 'completed' ? palette.success.main : palette.primary.main));
  var bodyLine = css(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteralLoose(["\n    min-width: 2.5rem;\n    max-width: 2.5rem;\n    width: 2.5 rem;\n    margin-right: 1rem;\n    height: 100%;\n    \n    & hr {\n      border-left: 3px ", " #d3d3d3;\n      height: 100%;\n      margin-top: 0;\n      margin-bottom: 0;\n    }\n  "])), monocromatico ? 'line' : 'dotted');
  var lineFirst = css(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteralLoose(["\n    min-width: 2.5rem;\n    max-width: 2.5rem;\n    width: 2.5 rem;\n    margin-right: 1rem;\n   \n    height: 1.5rem;\n    & hr {\n      border-left: 3px ", " #d3d3d3;\n      height: 100%;\n      margin-top: 0;\n      margin-bottom: 0;\n    }\n  "])), monocromatico ? 'line' : 'dotted');
  var handleClick = function handleClick(name) {
    onChange({
      value: name
    });
  };
  var Icon = icon;
  var head = jsx(Grid, {
    container: true,
    spacing: 2
  }, jsx(Grid, {
    item: true,
    xs: 2,
    css: css(_templateObject6$7 || (_templateObject6$7 = _taggedTemplateLiteralLoose(["padding-top: 0!important;"])))
  }, jsx(Box, {
    display: "flex",
    justifyContent: "center",
    css: firstItem ? null : lineFirst
  }, firstItem ? null : jsx("hr", null)), jsx(Box, {
    css: styleContentIcon,
    display: "flex",
    justifyContent: "center",
    alignContent: "center"
  }, jsx(Icon, null)), jsx(Box, {
    display: "flex",
    justifyContent: "center",
    css: !lastItem && lineFirst
  }, !lastItem ? jsx("hr", null) : jsx("div", null, " "))), jsx(Grid, {
    item: true,
    xs: 10,
    display: "flex",
    alignItems: lastItem ? 'flex-end' : 'center',
    css: !firstItem && css(_templateObject7$5 || (_templateObject7$5 = _taggedTemplateLiteralLoose(["\n            display: flex;\n          "])))
  }, jsx(Typography, {
    css: stylesTitle
  }, title)));
  var content = jsx(Grid, {
    container: true,
    spacing: 2,
    display: "flex",
    justify: "flex-end"
  }, jsx(Grid, {
    item: true,
    xs: 2,
    css: css(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteralLoose(["padding-top: 0!important;"])))
  }, jsx(Box, {
    display: "flex",
    justifyContent: "center",
    css: bodyLine
  }, !lastItem ? jsx("hr", null) : jsx("div", null, " "))), jsx(Grid, {
    item: true,
    xs: 10
  }, jsx(Typography, {
    css: stylesBody
  }, body), textAction !== '' && (status === 'new' || status === 'needscorrection') ? jsx(Box, {
    display: "flex",
    justifyContent: "" + (monocromatico ? 'start' : 'flex-end'),
    css: css(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteralLoose(["\n              margin-bottom: 1rem;\n            "])))
  }, jsx(ButtonDegrade, {
    id: id + "-button",
    textButton: textAction,
    icon: ArrowForwardIcon,
    onClick: function onClick() {
      return handleClick("" + textAction);
    },
    monocromatico: monocromatico
  })) : null, jsx(Grid, {
    container: true
  }, children && jsx(Grid, {
    item: true,
    xs: 12
  }, children))));
  return jsx(SimpleAccordion, {
    titulo: head,
    expanded: !(status === 'completed' && !isExpanded),
    showExpandIcon: status !== 'new',
    isTimeLine: true
  }, content);
};
CardProgres.propTypes = {
  id: propTypes.string,
  title: propTypes.string,
  body: propTypes.node,
  textAction: propTypes.string,
  icon: propTypes.any,
  status: propTypes.oneOf(['completed', 'needscorrection', 'inprogress', 'new', 'error']),
  firstItem: propTypes.bool,
  lastItem: propTypes.bool,
  onChange: propTypes.func,
  bgIconColor: propTypes.string,
  isExpanded: propTypes.bool,
  children: propTypes.node,
  monocromatico: propTypes.bool
};
var _templateObject$e, _templateObject2$e, _templateObject3$c, _templateObject4$8, _templateObject5$8, _templateObject6$8, _templateObject7$6, _templateObject8$4, _templateObject9$3, _templateObject10$2, _templateObject11$1, _templateObject12$1, _templateObject13$1, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22;
var Footer = function Footer(_ref) {
  var customizedFooter = _ref.customizedFooter,
    companyImage = _ref.companyImage,
    genericFooter = _ref.genericFooter,
    dynamicFooter = _ref.dynamicFooter,
    colorhr = _ref.colorhr,
    colorfooter = _ref.colorfooter,
    terminosyavisos = _ref.terminosyavisos,
    fontsectionone = _ref.fontsectionone,
    fontsectiontwo = _ref.fontsectiontwo,
    fontsectiontree = _ref.fontsectiontree,
    condusefarray = _ref.condusefarray,
    buroarray = _ref.buroarray,
    otros = _ref.otros,
    imagestext = _ref.imagestext,
    imagesTextFirstSection = _ref.imagesTextFirstSection,
    imagesTextSecondSection = _ref.imagesTextSecondSection,
    linkone = _ref.linkone,
    linktwo = _ref.linktwo,
    leyendas = _ref.leyendas,
    afi = _ref.afi,
    terminosyavisosafileft = _ref.terminosyavisosafileft,
    terminosyavisosafiright = _ref.terminosyavisosafiright;
  var matches = useMediaQuery('(min-width:768px)');
  var contenedor = css(_templateObject$e || (_templateObject$e = _taggedTemplateLiteralLoose(["\n    display: grid;\n\n    /* Smartphones (portrait and landscape) ----------- */\n    @media only screen and (min-width: 50px) {\n      grid-template-columns: 100vw;\n      grid-template-areas:\n        'divbrespacio'\n        'linktres'\n        'linktres3column'\n        'hrwidth'\n        'divbrcero'\n        'linkuno'\n        'linkuno3column'\n        'linkdos3column'\n        'linkdos'\n        'divbrone'\n        'hrwidthdos'\n        'linkcuatro'\n        'linkcinco'\n        'linkseis'\n        'divbrtwo'\n        'linksiete'\n        'linknueve'\n        'linkdiez'\n        'linkonce';\n      background-color: ", ";\n    }\n\n    /* Large screens ----------- */\n    @media only screen and (min-width: 768px) {\n      grid-template-columns: 10vw 1fr 1fr 1fr 1fr 1fr 10vw;\n      grid-template-areas:\n        'divbrcero divbrcero divbrcero divbrcero divbrcero divbrcero divbrcero'\n        'divleft linkuno linkdos linkdos linktres linktres divright'\n        'divleft linkuno3column linkuno3column linkuno3column linkdos3column linkdos3column divright'\n        'divbrone divbrone divbrone divbrone divbrone divbrone divbrone'\n        'hrwidth hrwidth hrwidth hrwidth hrwidth hrwidth hrwidth'\n        'divbr divbr divbr divbr divbr divbr divbr'\n        'divleftdos linkcuatro linkcuatro linkcuatro linkcuatro linkcuatro divrightdos'\n        'divleftdos divbrtwo divbrtwo divbrtwo divbrtwo divbrtwo divrightdos'\n        'divleftdos linksiete linksiete linksiete linksiete linksiete divrightdos'\n        'divleftdos linknueve linknueve linknueve linknueve linknueve divrightdos'\n        'divleftdos linkdiez linkdiez linkdiez linkdiez linkdiez divrightdos'\n        'divleftdos linkonce linkonce linkonce linkonce linkonce divrightdos';\n      // grid-gap: 10px;\n      background-color: ", ";\n      // padding: 10px;\n    }\n  "])), colorfooter, colorfooter);
  var divleft = css(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteralLoose(["\n    grid-area: divleft;\n  "])));
  var divright = css(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteralLoose(["\n    grid-area: divright;\n  "])));
  var divleftdos = css(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteralLoose(["\n    grid-area: divleft;\n  "])));
  var divrightdos = css(_templateObject5$8 || (_templateObject5$8 = _taggedTemplateLiteralLoose(["\n    grid-area: divright;\n  "])));
  var linkuno = css(_templateObject6$8 || (_templateObject6$8 = _taggedTemplateLiteralLoose(["\n    grid-area: ", ";\n  "])), customizedFooter ? 'linkuno3column' : 'linkuno');
  var linkdos = css(_templateObject7$6 || (_templateObject7$6 = _taggedTemplateLiteralLoose(["\n    grid-area: ", ";\n  "])), customizedFooter ? 'linkdos3column' : 'linkdos');
  var linktres = css(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteralLoose(["\n    grid-area: ", ";\n    padding-left: ", ";\n  "])), customizedFooter ? 'linktres3column' : 'linktres', matches ? 'none' : '32px');
  var linkcuatro = css(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteralLoose(["\n    grid-area: linkcuatro;\n  "])));
  var linksiete = css(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteralLoose(["\n    grid-area: linksiete;\n    grid-column: 80%;\n  "])));
  var linknueve = css(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteralLoose(["\n    grid-area: linknueve;\n    grid-column: 80%;\n    text-align: center;\n  "])));
  var hr = css(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteralLoose(["\n    border-left: 1px solid;\n    height: 30px;\n    margin: 0px 10px 0px 10px;\n    color: ", ";\n  "])), colorhr);
  var hrwidth = css(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteralLoose(["\n    grid-area: hrwidth;\n    border: 0.1px solid;\n    color: ", ";\n  "])), colorhr);
  var hrwidthdos = css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteralLoose(["\n    grid-area: hrwidthdos;\n    border: 0.1px solid;\n    color: ", ";\n  "])), colorhr);
  var divbr = css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteralLoose(["\n    grid-area: divbr;\n  "])));
  var divbrone = css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteralLoose(["\n    grid-area: divbrone;\n  "])));
  var divbrcero = css(_templateObject17 || (_templateObject17 = _taggedTemplateLiteralLoose(["\n    grid-area: divbrcero;\n  "])));
  var divbrtwo = css(_templateObject18 || (_templateObject18 = _taggedTemplateLiteralLoose(["\n    grid-area: divbrtwo;\n  "])));
  var divbrespacio = css(_templateObject19 || (_templateObject19 = _taggedTemplateLiteralLoose(["\n    grid-area: divbrespacio;\n  "])));
  var hrcss = css(_templateObject20 || (_templateObject20 = _taggedTemplateLiteralLoose(["\n    grid-area: hrcss;\n    border: none;\n    border-left: 1px solid hsla(200, 10%, 50%, 100);\n    height: 60px;\n    width: 1px;\n    padding-right: 20px;\n  "])));
  var anchortag = css(_templateObject21 || (_templateObject21 = _taggedTemplateLiteralLoose(["\n    text-decoration: none;\n    color: black;\n  "])));
  var footer = css(_templateObject22 || (_templateObject22 = _taggedTemplateLiteralLoose(["\n    width: 100vw;\n  "])));
  var theme = createMuiTheme({
    typography: {
      fontFamily: ['Roboto', 'arial'].join(',')
    }
  });
  var linkOneWithImage = [].concat(linkone, imagesTextFirstSection);
  var linkTwoWithImage = [].concat(linktwo, imagesTextSecondSection);
  return jsx("footer", null, jsx("div", {
    css: footer
  }, jsx(ThemeProvider, {
    theme: theme
  }, jsx(Typography$1, {
    variant: "h6"
  }, jsx("div", {
    css: contenedor
  }, jsx("div", {
    css: divleft,
    style: {
      display: matches ? true : 'none'
    }
  }), jsx("div", {
    css: divright,
    style: {
      display: matches ? true : 'none'
    }
  }), jsx("div", {
    css: divleftdos,
    style: {
      display: matches ? true : 'none'
    }
  }), jsx("div", {
    css: divrightdos,
    style: {
      display: matches ? true : 'none'
    }
  }), dynamicFooter || genericFooter ? null : jsx("div", {
    css: divbr
  }, jsx("br", null)), dynamicFooter || genericFooter ? null : jsx("div", {
    css: divbrone
  }, jsx("br", null)), jsx("div", {
    css: divbrcero
  }, jsx("br", null)), dynamicFooter || genericFooter ? null : jsx("div", {
    css: divbrtwo
  }, jsx("br", null)), dynamicFooter || genericFooter ? null : jsx("div", {
    css: divbrespacio
  }, jsx("br", null)), dynamicFooter || genericFooter ? null : jsx("div", {
    css: hrwidth
  }), dynamicFooter || genericFooter ? null : jsx("div", {
    css: hrwidthdos,
    style: {
      display: matches ? 'none' : true
    }
  }), jsx("div", {
    css: linkuno,
    id: "footer"
  }, jsx("div", {
    style: {
      fontSize: customizedFooter ? '15px' : fontsectionone.size,
      paddingLeft: matches ? '2%' : '10%',
      textDecoration: 'none',
      fontWeight: 'bold'
    }
  }, (genericFooter || dynamicFooter) && jsx(Grid$1, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  }, jsx(Grid$1, {
    item: true,
    sm: 12,
    md: 6
  }, jsx(Typography$1, {
    variant: "h6",
    style: {
      fontSize: '16px',
      fontWeight: 'bold'
    }
  }, dynamicFooter ? 'Tu crédito lo administraremos por:' : 'Somos un sitio seguro')), dynamicFooter && jsx(Grid$1, {
    item: true,
    sm: 12,
    md: 1,
    style: {
      marginLeft: '-50px'
    }
  }, companyImage)), customizedFooter && linkOneWithImage.length > 0 && linkOneWithImage.map(function (row, index) {
    return jsx("div", {
      key: index + 3
    }, jsx("br", null), jsx("div", {
      style: {
        display: 'table'
      }
    }, jsx("div", {
      style: {
        display: 'table-cell',
        verticalAlign: 'middle'
      }
    }, jsx("div", {
      style: {
        display: 'flex'
      }
    }, row.imagen, jsx("div", {
      style: {
        paddingLeft: row.imagen && '20px'
      }
    }, ' ', jsx("a", {
      style: {
        textDecoration: 'none',
        color: 'black'
      },
      href: row.link,
      target: "_blank",
      rel: "noreferrer"
    }, row.texto), jsx("div", {
      style: {
        display: row.extra ? true : 'none'
      }
    }, jsx("p", {
      style: {
        fontSize: '12px'
      }
    }, row.extra)))))));
  }), !customizedFooter && linkone.length > 0 && linkone.map(function (row, index) {
    return jsx("div", {
      key: index + 1
    }, jsx("p", null, jsx("a", {
      style: {
        textDecoration: 'none',
        color: 'black'
      },
      href: row.link,
      target: "_blank",
      rel: "noreferrer"
    }, row.texto)));
  }), genericFooter && jsx("div", null, jsx(Box$1, {
    mt: 2
  }, jsx(Grid$1, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  }, jsx(Grid$1, {
    item: true,
    sm: 6,
    md: 2
  }, jsx("a", {
    href: buroarray[0].link,
    target: "_blank",
    rel: "noreferrer"
  }, buroarray[0].imagen)), jsx(Grid$1, {
    item: true,
    sm: 6,
    md: 7,
    style: {
      textAlign: 'left'
    }
  }, jsx("p", {
    style: {
      fontSize: customizedFooter && '15px',
      fontWeight: customizedFooter && 'bold',
      marginBottom: '5px'
    }
  }, "Bur\xF3 de Entidades Financieras"), jsx("p", {
    style: {
      fontSize: customizedFooter && '15px',
      fontWeight: customizedFooter && 'bold'
    }
  }, buroarray[0].texto)))), jsx(Box$1, {
    mt: 2
  }, jsx(Grid$1, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  }, jsx(Grid$1, {
    item: true,
    sm: 6,
    md: 2
  }, jsx("a", {
    href: condusefarray[0].link,
    target: "_blank",
    rel: "noreferrer"
  }, condusefarray[0].imagen)), jsx(Grid$1, {
    item: true,
    sm: 6,
    md: 7,
    style: {
      textAlign: 'left'
    }
  }, jsx("p", {
    style: {
      fontSize: customizedFooter && '15px',
      fontWeight: customizedFooter && 'bold',
      marginBottom: '5px'
    }
  }, "CONDUSEF"), jsx("p", {
    style: {
      fontSize: customizedFooter && '15px',
      fontWeight: customizedFooter && 'bold'
    }
  }, condusefarray[0].texto))))))), jsx("div", {
    css: linkdos,
    id: "footer-link-two"
  }, jsx("div", {
    style: {
      fontSize: fontsectionone.size,
      paddingLeft: matches ? '2%' : '10%',
      textDecoration: 'none',
      fontWeight: 'bold'
    }
  }, !customizedFooter && linktwo.length > 0 && linktwo.map(function (row, index) {
    return jsx("strong", {
      key: index + 2
    }, jsx("p", null, jsx("a", {
      style: {
        textDecoration: 'none',
        color: 'black'
      },
      href: row.link,
      target: "_blank",
      rel: "noreferrer"
    }, row.texto)));
  }), customizedFooter && linkTwoWithImage.length > 0 && linkTwoWithImage.map(function (row, index) {
    return jsx("div", {
      key: index + 3
    }, jsx("br", null), jsx("div", {
      style: {
        display: 'table'
      }
    }, jsx("div", {
      style: {
        display: 'table-cell',
        verticalAlign: 'middle'
      }
    }, jsx("div", {
      style: {
        display: 'flex'
      }
    }, row.imagen, jsx("div", {
      style: {
        paddingLeft: '20px'
      }
    }, ' ', jsx("a", {
      style: {
        textDecoration: 'none',
        color: 'black'
      },
      href: row.link,
      target: "_blank",
      rel: "noreferrer"
    }, jsx("strong", {
      style: {
        fontSize: fontsectionone.redesSize
      }
    }, row.texto)), jsx("div", {
      style: {
        display: row.extra ? true : 'none'
      }
    }, jsx("strong", null, jsx("p", {
      style: {
        fontSize: fontsectiontwo.size
      }
    }, row.extra))))))));
  }), dynamicFooter && jsx("div", null, jsx(Box$1, {
    mt: 2
  }, jsx(Grid$1, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  }, jsx(Grid$1, {
    item: true,
    sm: 6,
    md: 3
  }, jsx("a", {
    href: buroarray[0].link,
    target: "_blank",
    rel: "noreferrer"
  }, buroarray[0].imagen)), jsx(Grid$1, {
    item: true,
    sm: 6,
    md: 7
  }, jsx("p", {
    style: {
      fontSize: customizedFooter && '14px',
      fontWeight: customizedFooter && 'bold',
      marginBottom: '5px'
    }
  }, "Bur\xF3 de Entidades Financieras"), jsx("p", {
    style: {
      fontSize: customizedFooter && '14px',
      fontWeight: customizedFooter && 'bold'
    }
  }, buroarray[0].texto)))), jsx(Box$1, {
    mt: 2
  }, jsx(Grid$1, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  }, jsx(Grid$1, {
    item: true,
    sm: 6,
    md: 3
  }, jsx("a", {
    href: condusefarray[0].link,
    target: "_blank",
    rel: "noreferrer"
  }, condusefarray[0].imagen)), jsx(Grid$1, {
    item: true,
    sm: 6,
    md: 7
  }, jsx("p", {
    style: {
      fontSize: customizedFooter && '14px',
      fontWeight: customizedFooter && 'bold',
      marginBottom: '5px'
    }
  }, "CONDUSEF"), jsx("p", {
    style: {
      fontSize: customizedFooter && '14px',
      fontWeight: customizedFooter && 'bold'
    }
  }, condusefarray[0].texto)))))), jsx("br", null)), jsx("div", {
    css: linktres,
    id: "footer-link-three"
  }, !customizedFooter && imagestext.length > 0 && imagestext.map(function (row, index) {
    return jsx("div", {
      key: index + 3
    }, jsx("br", null), jsx("div", {
      style: {
        display: 'table'
      }
    }, jsx("div", {
      style: {
        display: 'table-cell',
        verticalAlign: 'middle'
      }
    }, jsx("div", {
      style: {
        display: 'flex'
      }
    }, row.imagen, jsx("div", {
      style: {
        paddingLeft: '20px'
      }
    }, ' ', jsx("a", {
      style: {
        textDecoration: 'none',
        color: 'black'
      },
      href: row.link,
      target: "_blank",
      rel: "noreferrer"
    }, jsx("strong", {
      style: {
        fontSize: fontsectionone.redesSize
      }
    }, row.texto)), jsx("div", {
      style: {
        display: row.extra ? true : 'none'
      }
    }, jsx("strong", null, jsx("p", {
      style: {
        fontSize: fontsectiontwo.size
      }
    }, row.extra))))))));
  }), jsx("br", null)), genericFooter || dynamicFooter ? null : jsx("div", {
    css: linkcuatro,
    style: {
      display: afi ? 'none' : true
    },
    id: "footer-link-four"
  }, jsx("br", null), jsx(Grid$1, {
    container: true,
    direction: "row",
    justifyContent: "center",
    alignItems: "center"
  }, jsx(Grid$1, {
    item: true,
    sm: 12,
    md: 1
  }, jsx("a", {
    href: buroarray[0].link,
    target: "_blank",
    rel: "noreferrer"
  }, buroarray[0].imagen)), jsx(Grid$1, {
    item: true,
    sm: 12,
    md: 2,
    style: {
      textAlign: customizedFooter ? 'left' : 'center'
    }
  }, jsx("p", {
    style: {
      fontSize: customizedFooter && '13px',
      fontWeight: customizedFooter && 'normal'
    }
  }, buroarray[0].texto)), matches && jsx(Grid$1, {
    item: true,
    sm: 12,
    md: 1
  }, jsx("hr", {
    css: hrcss,
    style: {
      display: afi ? 'none' : true
    }
  })), jsx(Grid$1, {
    item: true,
    sm: 12,
    md: 1
  }, jsx("a", {
    href: condusefarray[0].link,
    target: "_blank",
    rel: "noreferrer"
  }, condusefarray[0].imagen)), jsx(Grid$1, {
    item: true,
    sm: 12,
    md: 2,
    style: {
      textAlign: customizedFooter ? 'left' : 'center'
    }
  }, jsx("p", {
    style: {
      fontSize: customizedFooter && '13px',
      fontWeight: customizedFooter && 'normal'
    }
  }, condusefarray[0].texto)), matches && jsx(Grid$1, {
    item: true,
    sm: 12,
    md: 1,
    style: {
      display: matches ? true : 'none'
    }
  }, jsx("hr", {
    id: "hrgps",
    css: hrcss,
    style: {
      display: afi ? 'none' : true
    }
  })), jsx(Grid$1, {
    item: true,
    sm: 12,
    md: 1
  }, jsx("a", {
    href: otros[0].link,
    target: "_blank",
    rel: "noreferrer"
  }, otros[0].imagen)), jsx(Grid$1, {
    item: true,
    sm: 12,
    md: 2,
    style: {
      textAlign: customizedFooter ? 'left' : 'center'
    }
  }, jsx("p", {
    style: {
      fontSize: customizedFooter && '13px',
      fontWeight: customizedFooter && 'normal'
    }
  }, otros[0].texto)))), jsx("div", {
    css: linksiete,
    id: "footer-link-seven"
  }, afi && terminosyavisosafileft.length > 0 && terminosyavisosafiright.length > 0 && jsx("div", {
    style: {
      display: 'flex',
      flexDirection: matches ? 'row' : 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: fontsectiontwo.size
    }
  }, jsx(Grid$1, {
    container: true,
    style: {
      textAlign: 'center'
    }
  }, terminosyavisosafileft.map(function (row, index) {
    return jsx(Grid$1, {
      item: true,
      xs: 12,
      sm: 6,
      key: index
    }, jsx("a", {
      style: {
        textDecoration: 'none',
        color: 'black'
      },
      href: terminosyavisosafileft[index].link,
      target: "_blank",
      rel: "noreferrer"
    }, terminosyavisosafileft[index].texto));
  })), jsx("div", {
    css: hr,
    style: {
      display: matches ? true : 'none'
    }
  }), jsx(Grid$1, {
    container: true,
    style: {
      textAlign: 'center'
    }
  }, terminosyavisosafiright.map(function (row, index) {
    return jsx(Grid$1, {
      item: true,
      xs: 12,
      sm: 6,
      key: index
    }, jsx("a", {
      style: {
        textDecoration: 'none',
        color: 'black'
      },
      href: terminosyavisosafiright[index].link,
      target: "_blank",
      rel: "noreferrer"
    }, terminosyavisosafiright[index].texto));
  }))), !afi || customizedFooter && jsx("div", {
    style: {
      display: 'flex',
      alignItems: 'left',
      justifyContent: 'center',
      fontSize: fontsectiontwo.size
    }
  }, jsx("a", {
    style: {
      textDecoration: 'none',
      color: 'black'
    },
    href: terminosyavisos[0].link,
    target: "_blank",
    rel: "noreferrer"
  }, terminosyavisos[0].texto), jsx("div", {
    css: hr
  }), jsx("a", {
    style: {
      textDecoration: 'none',
      color: 'black'
    },
    href: terminosyavisos[1].link,
    target: "_blank",
    rel: "noreferrer"
  }, terminosyavisos[1].texto))), jsx("div", {
    css: linknueve,
    style: {
      fontSize: fontsectiontree.size
    },
    id: "footer-link-nine"
  }, afi && leyendas.map(function (row, index) {
    return jsx("div", {
      key: index
    }, jsx("br", null), jsx("p", null, jsx("b", null, row.onetext, ' ', jsx("a", {
      css: anchortag,
      href: row.link,
      target: "_blank",
      rel: "noreferrer"
    }, row.link), ' ', row.twotext)));
  }), !afi && leyendas.map(function (row, index) {
    return jsx("div", {
      key: index,
      style: {
        textAlign: 'center'
      }
    }, jsx("br", null), jsx("p", {
      style: {
        fontSize: customizedFooter && '14px',
        fontWeight: customizedFooter && 'normal'
      }
    }, row.onetext, ' ', jsx("a", {
      css: anchortag,
      href: row.link,
      target: "_blank",
      rel: "noreferrer"
    }, row.link), ' ', row.twotext, " ", row.threetext, customizedFooter && jsx("br", null), customizedFooter && jsx("br", null), customizedFooter && row.fourtext));
  })))))));
};
Footer.propTypes = {
  companyImage: propTypes.element,
  genericFooter: propTypes.bool,
  dynamicFooter: propTypes.bool,
  customizedFooter: propTypes.bool,
  linkone: propTypes.array,
  linktwo: propTypes.array,
  linktree: propTypes.array,
  leyendas: propTypes.array,
  imagesText: propTypes.array,
  imagesTextFirstSection: propTypes.array,
  imagesTextSecondSection: propTypes.array,
  condusefarray: propTypes.array,
  buroarray: propTypes.array,
  otros: propTypes.array,
  fontsectionone: propTypes.object,
  fontsectiontwo: propTypes.object,
  fontsectiontree: propTypes.object,
  terminosyavisos: propTypes.array,
  colorfooter: propTypes.string,
  colorhr: propTypes.string,
  afi: propTypes.bool,
  terminosyavisosafileft: propTypes.array,
  terminosyavisosafiright: propTypes.array
};
Footer.defaultProps = {
  customizedFooter: false,
  genericFooter: false,
  imagesTextFirstSection: [],
  imagesTextSecondSection: [],
  imagestext: [],
  dynamicFooter: false,
  linkone: [],
  linktwo: [],
  linktree: [{
    link: 'https://home.apoyoeconomico.com.mx/como-funciona.html',
    texto: 'COMO FUNCIONA'
  }],
  leyendas: [{
    onetext: 'Transmisión segura de datos Certificado SSL',
    twotext: 'Transmisión segura de datos Certificado SSL',
    link: 'www.home.apoyoeconomico.com.mx/'
  }, {
    onetext: 'Apoyo Económico Familiar S.A. de C.V. SOFOM ENR | Insurgentes Sur 1228, 5 piso, Col. Tlacoquemécatl del Valle, Del. Benito Juárez, México D.F.',
    link: 'www.independencia.com.mx'
  }, {
    onetext: 'Estamos constituidos como una SOFOM, ENR, es decir, no requerimos autorización de la SHCP para la realización de operaciones de crédito, y estamos sujetos a la supervisión de la Comisión Nacional Bancaria y de Valores únicamente para efectos de lo dispuesto por el artículo 56 de la Ley General de Organizaciones y Actividades Auxiliares del Crédito'
  }],
  fontsectionone: {
    family: 'roboto',
    size: '14px',
    redesSize: '20px'
  },
  fontsectiontwo: {
    family: 'roboto',
    size: '14px'
  },
  fontsectiontree: {
    family: 'roboto',
    size: '14px'
  },
  terminosyavisos: [{
    link: 'https://home.apoyoeconomico.com.mx/uso-privacidad-sitio.html',
    texto: 'Uso y Privacidad del sitio'
  }, {
    link: 'https://home.apoyoeconomico.com.mx/aviso-privacidad.html',
    texto: 'Aviso de privacidad'
  }],
  colorfooter: '#eeedf0',
  colorhr: 'gray',
  afi: false,
  terminosyavisosafileft: [{
    link: 'https://home.apoyoeconomico.com.mx/uso-privacidad-sitio.html',
    texto: 'Formulario CCPA'
  }, {
    link: 'https://home.apoyoeconomico.com.mx/aviso-privacidad.html',
    texto: 'Politica de Privacidad'
  }, {
    link: 'https://home.apoyoeconomico.com.mx/uso-privacidad-sitio.html',
    texto: 'Formulario CCPA'
  }],
  terminosyavisosafiright: [{
    link: 'https://home.apoyoeconomico.com.mx/uso-privacidad-sitio.html',
    texto: 'Uso y Privacidad del sitio'
  }]
};
var _excluded$5 = ["className", "type", "value", "label", "onBlur", "pattern", "error", "required", "disabled", "inputmode", "errorMessage", "helperText", "name", "id", "fullWidth", "size", "margin", "variant", "multiline", "rowsMax", "rows", "placeholder", "inputComponent", "onError", "onChange", "accept", "transfor", "patternFlags"];
var MaterialInput = /*#__PURE__*/function (_Component) {
  _inheritsLoose(MaterialInput, _Component);
  function MaterialInput(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this._handleChange = _this._handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  var _proto = MaterialInput.prototype;
  _proto._handleChange = function _handleChange(event) {
    event.preventDefault();
    var value = String(event.target.value);
    var component = {
      value: value,
      error: false,
      errorType: ''
    };
    var error = {
      messagge: '',
      detail: ''
    };
    if (this.props.accept) {
      var rejected = RegExp("[^" + this.props.accept + "]", 'gi');
      value = value.replace(rejected, '');
    }
    if (this.props.transform) {
      value = String(this.props.transform(value));
    }
    if (this.props.pattern && (this.props.required ? true : value.length > 0)) {
      component.error = !RegExp(this.props.pattern, this.props.patternFlags).test(value);
      component.errorType = component.error ? 'pattern' : '';
      if (component.error) {
        error.messagge = 'Invalid pattern';
        error.detail = "The pattern " + this.props.pattern + " did not match.";
      }
    }
    if (this.props.required) {
      var required = value === '';
      component.error = required || component.error;
      component.errorType = required ? 'required' : component.errorType;
      if (required) {
        error.messagge = 'Required field';
        error.detail = "Required field";
      }
    }
    component.value = value;
    this.props.onChange(event, component);
    if (error.messagge && this.props.onError) {
      this.props.onError(error);
    }
  };
  _proto.render = function render() {
    var _label = typeof this.props.label === 'string' ? this.props.label.replace(/\s+/g, '-') + "_input" : '';
    var _this$props = this.props,
      className = _this$props.className,
      type = _this$props.type,
      value = _this$props.value,
      label = _this$props.label,
      onBlur = _this$props.onBlur,
      pattern = _this$props.pattern,
      error = _this$props.error,
      required = _this$props.required,
      disabled = _this$props.disabled,
      inputmode = _this$props.inputmode,
      errorMessage = _this$props.errorMessage,
      helperText = _this$props.helperText,
      name = _this$props.name,
      id = _this$props.id,
      fullWidth = _this$props.fullWidth,
      size = _this$props.size,
      margin = _this$props.margin,
      variant = _this$props.variant,
      multiline = _this$props.multiline,
      rowsMax = _this$props.rowsMax,
      rows = _this$props.rows,
      placeholder = _this$props.placeholder,
      inputComponent = _this$props.inputComponent,
      otherProps = _objectWithoutPropertiesLoose(_this$props, _excluded$5);
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement(TextField$1, _extends({
      className: (error ? 'is-danger' : '') + " " + (String(value) !== '' ? 'is-active' : ''),
      id: id ? id + "-input" : _label,
      label: label,
      error: error,
      name: name,
      size: size,
      margin: margin,
      value: value,
      onChange: this._handleChange,
      onBlur: onBlur,
      pattern: pattern,
      required: required,
      disabled: disabled,
      placeholder: placeholder || label,
      alt: "Label - " + label,
      "data-placeholder": "" + (required ? '* ' : '') + label,
      type: type,
      inputProps: {
        inputMode: inputmode
      },
      InputProps: {
        inputComponent: inputComponent
      },
      variant: variant,
      fullWidth: fullWidth,
      helperText: error ? errorMessage || helperText : helperText,
      multiline: multiline,
      rowsMax: rowsMax,
      rows: rows
    }, otherProps)));
  };
  return MaterialInput;
}(Component);
MaterialInput.defaultProps = {
  fullWidth: true,
  variant: 'outlined',
  patternFlags: 'gi'
};
var MaterialInput$1 = withThemeProps(MaterialInput, 'MFMaterialInput');
var _templateObject$f, _templateObject2$f, _templateObject3$d, _templateObject4$9, _templateObject5$9, _templateObject6$9, _templateObject7$7, _templateObject8$5, _templateObject9$4, _templateObject10$3;
function CardTasks(inProps) {
  var props = useThemeProps({
    props: inProps,
    name: 'MFCardTasks'
  });
  var _props$background = props.background,
    background = _props$background === void 0 ? '#fdfcfc' : _props$background,
    _props$color = props.color,
    color = _props$color === void 0 ? '#202020' : _props$color,
    _props$name = props.name,
    name = _props$name === void 0 ? 'JUAN dOMÍNGUEZ SÁNCHES' : _props$name,
    _props$title = props.title,
    title = _props$title === void 0 ? 'CUENTA BANCARIA' : _props$title,
    _props$body = props.body,
    body = _props$body === void 0 ? 'Tienes una accion pendiente, Necesitas configurar tu cuenta bancaria' : _props$body,
    _props$status = props.status,
    status = _props$status === void 0 ? 'def' : _props$status,
    _props$textCta = props.textCta,
    textCta = _props$textCta === void 0 ? 'CONFIGURAR' : _props$textCta,
    _props$isActionable = props.isActionable,
    isActionable = _props$isActionable === void 0 ? true : _props$isActionable,
    icon = props.icon,
    onChange = props.onChange;
  var _useTheme = useTheme(),
    palette = _useTheme.palette;
  var root = css(_templateObject$f || (_templateObject$f = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    background: ", ";\n    color: ", ";\n    border-radius: 10px;\n    width: 100%;\n  "])), background, color);
  var alertStatus = css(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteralLoose(["\n    background: ", "; \n    color: white; \n    border-radius: 5px; \n    padding:0.2rem 0;\n  "])), status === 'New' || status === 'Retry' ? palette.warning.main : status === 'InProgress' ? palette.primary.main : status === 'Completed' ? palette.success.dark : status === 'Error' ? palette.error.dark : palette.warning.main);
  var dispatchClick = function dispatchClick(e) {
    isActionable && onChange(e);
  };
  var Icon = icon ? icon : Warning;
  return jsx(CardElevation, {
    noPadding: true
  }, jsx(Grid, {
    container: true,
    display: "flex",
    justify: "center",
    css: root,
    onClick: function onClick(e) {
      return dispatchClick(e);
    }
  }, jsx(Grid, {
    item: true,
    xs: 12
  }, jsx(Grid, {
    container: true,
    spacing: 1,
    display: "flex",
    justify: "center",
    css: css(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteralLoose(["padding: 0.5rem 1rem;"])))
  }, jsx(Grid, {
    item: true,
    xs: 2,
    sm: 1,
    css: css(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteralLoose(["text-align: center;"])))
  }, jsx(AssignmentInd, null)), jsx(Grid, {
    item: true,
    xs: 10,
    sm: 11
  }, jsx(Typography, null, jsx("strong", null, name.toUpperCase()))))), jsx("hr", {
    css: css(_templateObject5$9 || (_templateObject5$9 = _taggedTemplateLiteralLoose(["border-color: white; width: 100%;"])))
  }), jsx(Grid, {
    item: true,
    xs: 12,
    css: css(_templateObject6$9 || (_templateObject6$9 = _taggedTemplateLiteralLoose(["padding: 0.8rem 1rem;"])))
  }, jsx(Grid, {
    container: true,
    spacing: 1,
    css: alertStatus,
    display: "flex",
    justify: isActionable ? 'center' : 'flex-start',
    alignItems: "center"
  }, jsx(Grid, {
    item: true,
    xs: 2,
    css: css(_templateObject7$7 || (_templateObject7$7 = _taggedTemplateLiteralLoose(["text-align: center;"])))
  }, jsx(Icon, null)), jsx(Grid, {
    item: true,
    xs: 6,
    sm: 5
  }, jsx(Typography, null, title.toUpperCase())), isActionable && jsx(Grid, {
    item: true,
    xs: 4,
    sm: 5,
    css: css(_templateObject8$5 || (_templateObject8$5 = _taggedTemplateLiteralLoose(["cursor:pointer; text-align: end!important;"])))
  }, jsx(Typography, {
    css: css(_templateObject9$4 || (_templateObject9$4 = _taggedTemplateLiteralLoose(["font-size: 0.8rem!important;@media(min-width: 768px){font-size: 0.9rem!important;}"]))),
    textAlign: "center"
  }, textCta))), jsx(Grid, {
    item: true,
    css: css(_templateObject10$3 || (_templateObject10$3 = _taggedTemplateLiteralLoose(["margin-left: 2rem!important;"])))
  }, jsx("br", null), jsx(Typography, null, body)))));
}
CardTasks.propTypes = {
  background: propTypes.string,
  color: propTypes.string,
  name: propTypes.string,
  title: propTypes.string,
  body: propTypes.any,
  status: propTypes.string,
  icon: propTypes.object,
  onChange: propTypes.func,
  textCta: propTypes.string,
  isActionable: propTypes.bool
};
CardTasks.defaultProps = {
  background: '#fdfcfc',
  color: '#202020',
  name: 'JUAN dOMÍNGUEZ SÁNCHES',
  title: 'CUENTA BANCARIA',
  body: 'Tienes una accion pendiente, Necesitas configurar tu cuenta bancaria',
  status: 'def',
  textCta: 'CONFIGURAR',
  isActionable: true
};
var _templateObject$g;
function DatePicker(props) {
  var formControl = css(_templateObject$g || (_templateObject$g = _taggedTemplateLiteralLoose(["\n    margin: theme.spacing(0.5);\n    margin-right: 0.5rem !important;\n  "])));
  var DAYS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
  var YESTERDAY = new Date();
  var _useState = useState([]),
    obj = _useState[0],
    setObj = _useState[1];
  var _useState2 = useState([]),
    years = _useState2[0],
    setYears = _useState2[1];
  var _useState3 = useState({
      day: null,
      month: null,
      year: null
    }),
    state = _useState3[0],
    setState = _useState3[1];
  var _useState4 = useState(),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState(true),
    onChangeValue = _useState5[0],
    setOnChangeValue = _useState5[1];
  var refState = useRef(_extends({}, state));
  useEffect(function () {
    var mount = function mount() {
      try {
        return Promise.resolve(newArrayYears()).then(function () {
          refState.current = _extends({}, state);
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };
    console.log('---SE MONTO---', state);
    mount();
  }, []);
  useEffect(function () {
    orderFormatDay();
  }, [props.formato, years]);
  useEffect(function () {
    console.log('<<<cambio PROPS VALUE>>>', props.value);
    if (props.value instanceof Date && props.value.day !== state.day && props.value.month !== state.month && props.value.year !== state.year) {
      console.log('tipe date');
      setState({
        day: props.value.getDate(),
        month: props.value.getMonth(),
        year: props.value.getFullYear()
      });
    } else if (props.value instanceof Object && props.value.day !== state.day && props.value.month !== state.month && props.value.year !== state.year) {
      console.log('tupe object');
      setState({
        day: props.value.day,
        month: props.value.month,
        year: props.value.year
      });
    }
    setOnChangeValue(false);
  }, [props.value]);
  useEffect(function () {
    orderFormatDay();
  }, [years]);
  useEffect(function () {
    newArrayYears();
  }, [props.aniosMaximos, props.aniosMinimos]);
  useEffect(function () {
    if (JSON.stringify(refState.current) !== JSON.stringify(state)) {
      console.log('<<<CAMNIO EL STATE...', state, refState.current);
      if (state.day && state.month && state.year) {
        evaluation();
        refState.current = _extends({}, state);
      }
    }
  }, [state]);
  var orderFormatDay = function orderFormatDay() {
    switch (props.formato) {
      case 'DD/MM/AAAA':
        setObj([{
          name: 'day',
          label: props.dayLabel,
          values: DAYS
        }, {
          name: 'month',
          label: props.monthLabel,
          values: props.months
        }, {
          name: 'year',
          label: props.yearLabel,
          values: years
        }]);
        break;
      case 'MM/DD/AAAA':
        setObj([{
          name: 'month',
          label: props.monthLabel,
          values: props.months
        }, {
          name: 'day',
          label: props.dayLabel,
          values: DAYS
        }, {
          name: 'year',
          label: props.yearLabel,
          values: years
        }]);
        break;
      case 'AAAA/MM/DD':
        setObj([{
          name: 'year',
          label: props.yearLabel,
          values: years
        }, {
          name: 'month',
          label: props.monthLabel,
          values: props.months
        }, {
          name: 'day',
          label: props.dayLabel,
          values: DAYS
        }]);
        break;
    }
  };
  var newArrayYears = function newArrayYears() {
    var years = [];
    var LAST_YEAR = new Date();
    LAST_YEAR.setFullYear(YESTERDAY.getFullYear() - props.aniosMinimos);
    var FIRST_YEAR = new Date();
    FIRST_YEAR.setFullYear(YESTERDAY.getFullYear() - props.aniosMaximos);
    FIRST_YEAR.setMonth(YESTERDAY.getMonth() - props.mesesMaximos);
    for (var i = LAST_YEAR.getFullYear(); i >= FIRST_YEAR.getFullYear(); i--) {
      years = [].concat(years, [i]);
    }
    setYears(years);
  };
  var evaluation = function evaluation() {
    try {
      var dateEntered = parse(parseInt(state.year) + "-" + parseInt(state.month) + "-" + parseInt(state.day), 'yyyy-MM-dd', new Date());
      console.log('<<<SE EVALUA CON...>>>', dateEntered);
      if (isValid(dateEntered)) {
        var LAST_YEAR = new Date();
        LAST_YEAR.setFullYear(YESTERDAY.getFullYear() - props.aniosMinimos);
        var FIRST_YEAR = new Date();
        FIRST_YEAR.setFullYear(YESTERDAY.getFullYear() - props.aniosMaximos);
        FIRST_YEAR.setMonth(YESTERDAY.getMonth() - props.mesesMaximos);
        if (dateEntered > LAST_YEAR) {
          if (onChangeValue) {
            props.onChange(format(dateEntered, 'dd.MM.yyyy'), {
              day: dateEntered.getDate(),
              month: dateEntered.getMonth() + 1,
              year: dateEntered.getFullYear()
            });
          }
          props.onError({
            errorType: 'La fecha no alcanza la edad minima'
          });
          setError(props.helperText ? props.helperText : props.errorMessage);
          return Promise.resolve(1);
        } else if (dateEntered < FIRST_YEAR) {
          if (onChangeValue) {
            props.onChange(format(dateEntered, 'dd.MM.yyyy'), {
              day: dateEntered.getDate(),
              month: dateEntered.getMonth() + 1,
              year: dateEntered.getFullYear()
            });
          }
          props.onError({
            errorType: 'La fecha supera la edad maxima'
          });
          setError(props.helperText ? props.helperText : props.errorMessage);
          return Promise.resolve(-1);
        }
        if (onChangeValue) {
          props.onChange(format(dateEntered, 'dd.MM.yyyy'), {
            day: dateEntered.getDate(),
            month: dateEntered.getMonth() + 1,
            year: dateEntered.getFullYear()
          });
        }
        setError('');
        return Promise.resolve(0);
      } else {
        if (onChangeValue) {
          props.onChange('', {
            day: state.day,
            month: state.month,
            year: state.year
          });
        }
        props.onError({
          errorType: 'La fecha no es valida'
        });
        setError(props.errorMessage);
      }
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var handleChange = function handleChange(event) {
    try {
      var _extends2;
      setOnChangeValue(true);
      setError('');
      var name = event.target.name;
      return Promise.resolve(setState(_extends({}, state, (_extends2 = {}, _extends2[name] = Number(event.target.value), _extends2)))).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };
  return jsx(Grid, {
    container: true
  }, props.title !== '' && jsx(Grid, {
    item: true,
    xs: 12
  }, jsx(FormControl, {
    style: {
      paddingLeft: 5,
      marginBottom: 10
    }
  }, jsx(FormLabel, {
    component: "legend"
  }, props.title))), jsx(Grid, {
    item: true,
    xs: 12,
    style: {
      minWidth: 360
    }
  }, obj === null || obj === void 0 ? void 0 : obj.map(function (item, key) {
    var _item$values;
    return jsx(FormControl, {
      variant: "outlined",
      css: formControl,
      key: key + 1
    }, jsx(InputLabel, {
      htmlFor: "outlined-age-native-simple",
      key: key + 2
    }, item.label), jsx(Select$1, {
      key: key,
      disabled: props.disabled,
      autoWidth: true,
      "native": true,
      value: props.value[item.name] ? props.value[item.name] : state[item.name] || '',
      onChange: handleChange,
      label: "" + item.label,
      inputProps: {
        name: "" + item.name,
        id: 'outlined-age-native-simple'
      }
    }, jsx("option", {
      key: "nonedia",
      "aria-label": "None",
      value: "",
      disabled: true
    }), item === null || item === void 0 ? void 0 : (_item$values = item.values) === null || _item$values === void 0 ? void 0 : _item$values.map(function (row, index) {
      return jsx("option", {
        key: index + 1,
        value: item.name === 'month' ? index + 1 : row
      }, row);
    })));
  })), jsx(Grid, {
    item: true,
    xs: 12
  }, jsx(FormControl, {
    error: error
  }, jsx(FormHelperText, null, error === '' ? '' : error))));
}
DatePicker.propTypes = {
  helperText: propTypes.string,
  title: propTypes.string,
  formato: propTypes.oneOf(['DD/MM/AAAA', 'MM/DD/AAAA', 'AAAA/MM/DD']),
  aniosMaximos: propTypes.number,
  aniosMinimos: propTypes.number,
  mesesMaximos: propTypes.number,
  disabled: propTypes.bool,
  onError: propTypes.func,
  onChange: propTypes.func,
  value: propTypes.oneOfType([propTypes.object, propTypes.instanceOf(Date)])
};
DatePicker.defaultProps = {
  aniosMaximos: 90,
  mesesMaximos: 11,
  aniosMinimos: 18,
  title: 'Fecha de nacimiento',
  formato: 'DD/MM/AAAA',
  onError: function onError() {},
  months: ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'],
  monthLabel: 'Mes',
  dayLabel: 'Día',
  yearLabel: 'Año',
  errorMessage: 'La fecha introducida es invalida',
  value: {},
  onChange: function onChange() {}
};
var DatePicker$1 = withThemeProps(DatePicker, 'MFSelectDatePicker');
var monthToDay = function monthToDay(year, month) {
  var anioParam = parseInt(year);
  var daysOffMonth = new Date(anioParam, month, 0).getDate();
  var arrayelement = [];
  for (var index = 1; index <= daysOffMonth; index++) {
    arrayelement.push(index);
  }
  return arrayelement;
};
function sumarDias(fecha, dias) {
  fecha.setDate(fecha.getDate() + dias);
  return fecha;
}
var indexMonth = function indexMonth(month, months) {
  var meses = [].concat(months);
  var index = meses.indexOf(month);
  return index;
};
var selectDays = function selectDays(day, days, mesmaximo, messelection) {
  var arrayDias = [];
  if (mesmaximo === messelection) {
    for (var index = 1; index <= day; index++) {
      arrayDias.push(index);
    }
  } else {
    for (var _index = 1; _index <= days.length; _index++) {
      arrayDias.push(_index);
    }
  }
  return arrayDias;
};
var selectMonths = function selectMonths(month, months) {
  var meses = [].concat(months);
  var pos = parseInt(month);
  var elementosEliminados = meses.splice(0, pos);
  return elementosEliminados;
};
var fechaDateConvert = function fechaDateConvert(year, month, day) {
  var fecha = '';
  if (year > 0 && year !== undefined || month > 0 && year !== undefined || day > 0 && year !== undefined) {
    var date = new Date(year + "/" + month + "/" + day);
    console.log("date", date);
    fecha = "" + format(date, 'dd.MM.yyyy');
    console.log("fecha", fecha);
    return fecha;
  } else {
    return 'Invalid Date';
  }
};
var generatorOffYears = function generatorOffYears(minYears, maxYears, maxMonths) {
  var d = new Date();
  var a = new Date();
  var diasMaximo = parseFloat(maxYears * 365.2425 + maxMonths * 30.417);
  var diasMinimo = parseFloat(minYears * 365.2425);
  var hoy = d.getDate();
  var mesActual = d.getMonth() + 1;
  var fechamax = new Date(sumarDias(d, -diasMinimo));
  var aniomaximo = fechamax.getFullYear();
  var mesmaximo = mesActual;
  var diamaximo = hoy;
  var fechamin = new Date(sumarDias(a, -diasMaximo));
  var aniominimo = fechamin.getFullYear();
  var mesminimo = fechamin.getMonth();
  var diaminimo = fechamin.getDay();
  var arrayAnios = [];
  for (var index = aniomaximo; index >= aniominimo; index--) {
    arrayAnios.push(index);
  }
  return {
    anios: arrayAnios,
    aniomaximo: aniomaximo,
    aniominimo: aniominimo,
    mesmaximo: mesmaximo,
    diamaximo: diamaximo,
    mesminimo: mesminimo,
    diaminimo: diaminimo
  };
};
var _excluded$6 = ["birthday", "banderaError", "onError", "helperTitle", "fontsize", "fechaDefault", "onChange", "dateFormat", "monthNames", "helperText", "mensajeError", "minYears", "maxYears", "maxMonths", "disabled"];
var _templateObject$h, _templateObject2$g;
var useStyles$3 = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(.5)
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    }
  };
});
var contenedor = css(_templateObject$h || (_templateObject$h = _taggedTemplateLiteralLoose(["\nmargin: 10px auto;\nwidth: 100%;\ndisplay: flex;\nalign-items: left;\njustify-content: left;\npadding-left: 5px;\n"])));
var item = css(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteralLoose(["\n\n"])));
var SelectDatePicker = function SelectDatePicker(_ref) {
  var birthday = _ref.birthday,
    banderaError = _ref.banderaError,
    onError = _ref.onError,
    helperTitle = _ref.helperTitle,
    fontsize = _ref.fontsize,
    fechaDefault = _ref.fechaDefault,
    onChange = _ref.onChange,
    dateFormat = _ref.dateFormat,
    monthNames = _ref.monthNames,
    helperText = _ref.helperText,
    mensajeError = _ref.mensajeError,
    minYears = _ref.minYears,
    maxYears = _ref.maxYears,
    maxMonths = _ref.maxMonths,
    disabled = _ref.disabled,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  var classes = useStyles$3();
  var _React$useState = React.useState({
      dia: '',
      mes: '',
      anio: ''
    }),
    state = _React$useState[0],
    setState = _React$useState[1];
  var _useState = useState([]),
    year = _useState[0],
    setYear = _useState[1];
  var _useState2 = useState([]),
    numDias = _useState2[0],
    setNumDias = _useState2[1];
  var _useState3 = useState(monthNames),
    meses = _useState3[0],
    setMeses = _useState3[1];
  var _useState4 = useState(monthNames),
    mesesDefault = _useState4[0];
  var _useState5 = useState(),
    fechaDate = _useState5[0],
    setFechaDate = _useState5[1];
  var _useState6 = useState(false),
    error = _useState6[0],
    setError = _useState6[1];
  var prevErrorRef = useRef(error);
  var prevStateRef = useRef(state);
  var _useState7 = useState({
      dia: '',
      mes: '',
      anio: ''
    }),
    fechaMaxima = _useState7[0],
    setFechaMaxima = _useState7[1];
  var _useState8 = useState({
      dia: '',
      mes: '',
      anio: ''
    }),
    fechaMinima = _useState8[0],
    setFechaMinima = _useState8[1];
  var _useState9 = useState({
      minYears: minYears,
      maxYears: maxYears,
      maxMonths: maxMonths
    }),
    dateRemote = _useState9[0],
    setDateRemote = _useState9[1];
  var prevDateRemoteRef = useRef();
  var handleChange = function handleChange(event) {
    var _extends2;
    var name = event.target.name;
    setState(_extends({}, state, (_extends2 = {}, _extends2[name] = event.target.value, _extends2)));
  };
  var generador = function generador(aniominimoremote, aniomaximoremote, mesmaximoremote) {
    var _generatorOffYears = generatorOffYears(aniominimoremote, aniomaximoremote, mesmaximoremote),
      anios = _generatorOffYears.anios,
      aniomaximo = _generatorOffYears.aniomaximo,
      aniominimo = _generatorOffYears.aniominimo,
      mesmaximo = _generatorOffYears.mesmaximo,
      diamaximo = _generatorOffYears.diamaximo,
      mesminimo = _generatorOffYears.mesminimo,
      diaminimo = _generatorOffYears.diaminimo;
    setYear(anios);
    setFechaMaxima(_extends({}, fechaMaxima, {
      anio: aniomaximo,
      mes: mesmaximo,
      dia: diamaximo
    }));
    setFechaMinima(_extends({}, fechaMinima, {
      anio: aniominimo,
      mes: mesminimo,
      dia: diaminimo
    }));
    if (fechaDefault) {
      setState(_extends({}, state, {
        anio: aniomaximo,
        mes: parseInt(mesmaximo - 1),
        dia: diamaximo
      }));
    }
    if (birthday && birthday !== null) {
      setState(_extends({}, state, {
        anio: birthday.year,
        mes: parseInt(birthday.month - 1),
        dia: birthday.day
      }));
    }
  };
  useEffect(function () {
    prevDateRemoteRef.current = _extends({}, dateRemote);
    setDateRemote({
      minYears: minYears,
      maxYears: maxYears,
      maxMonths: maxMonths
    });
  }, [minYears, maxYears, maxMonths]);
  useEffect(function () {
    if (prevDateRemoteRef.current !== dateRemote && dateRemote.minYears !== '' && dateRemote.maxYears !== '' && dateRemote.maxmonths !== '') {
      generador(dateRemote.minYears, dateRemote.maxYears, dateRemote.maxMonths);
    }
    prevDateRemoteRef.current = dateRemote;
  }, [dateRemote, prevDateRemoteRef]);
  useEffect(function () {
    if (fechaDate === 'Invalid Date' && fechaDate !== undefined) {
      setError(true);
      onError(true);
    }
    if (fechaDate !== 'Invalid Date' && fechaDate !== undefined) {
      setError(false);
      onChange(fechaDate);
    }
    if (prevErrorRef.current !== error) {
      if (state.dia !== '' && state.mes !== '' && state.anio !== '') {
        setError(false);
      } else {
        setError(true);
      }
    }
    prevErrorRef.current = error;
  }, [fechaDate, error]);
  useEffect(function () {
    var diaactual = parseInt(state.dia);
    if (numDias.length > 0 && diaactual !== undefined && diaactual !== isNaN && error === false) {
      var valordia = numDias.find(function (element) {
        return element === diaactual;
      });
      if (valordia === undefined) {
        setState(_extends({}, state, {
          dia: ''
        }));
        setFechaDate('Invalid Date');
      }
    }
  }, [numDias]);
  useEffect(function () {
    if (meses.length > 0 && state.mes !== '' && state.mes !== undefined && state.mes !== isNaN && error === false) {
      var mesactual = parseInt(state.mes) + 1;
      var valormes = meses.length >= mesactual;
      if (!valormes) {
        setState(_extends({}, state, {
          mes: ''
        }));
        setFechaDate('Invalid Date');
      }
    }
  }, [meses]);
  useEffect(function () {
    if (state.dia !== "" && state.mes !== "" && state.anio === "") {
      setFechaDate('Invalid Date');
    }
    if (state.dia !== "" && state.mes === "" && state.anio !== "") {
      setFechaDate('Invalid Date');
    }
    if (state.dia === "" && state.mes !== "" && state.anio !== "") {
      setFechaDate('Invalid Date');
    }
    var anioComparastate = parseInt(state.anio);
    var anioComparaMinimo = parseInt(fechaMinima.anio);
    if (anioComparastate === anioComparaMinimo && state.mes !== "" && state.dia !== "") {
      var diasdelmes = monthToDay(state.anio, fechaMinima.mes);
      var dias = selectDays(fechaMinima.dia, diasdelmes, fechaMinima.mes, fechaMinima.mes);
      setNumDias(dias);
      var mesesMaximo = selectMonths(parseInt(fechaMinima.mes) + 1, mesesDefault);
      setMeses(mesesMaximo);
    }
  }, [state]);
  useEffect(function () {
    var anioComparastate = parseInt(state.anio);
    var anioComparaMaximo = parseInt(fechaMaxima.anio);
    var anioComparaMinimo = parseInt(fechaMinima.anio);
    var diaState = parseInt(state.dia);
    var mesState = parseInt(state.mes) + 1;
    var anioState = parseInt(state.anio);
    if (prevStateRef.current.dia !== undefined && prevStateRef.current.mes !== undefined && prevStateRef.current.anio !== undefined && state.dia !== '' && state.mes !== '' && state.anio !== '') {
      var fechaCompleta = fechaDateConvert(anioState, mesState, diaState);
      console.log("paso setFechaDate");
      setFechaDate(fechaCompleta);
      setError(false);
    } else {
      setError(true);
    }
    if (anioComparastate !== anioComparaMaximo && anioComparastate !== anioComparaMinimo && state.dia !== '' && state.mes !== '' && state.anio !== '') {
      setMeses(mesesDefault);
      var diasdelmes = monthToDay(state.anio, parseInt(state.mes) + 1);
      var dias = selectDays(fechaMaxima.dia, diasdelmes, fechaMaxima.mes, parseInt(state.mes) + 1);
      setNumDias(dias);
    }
    if (anioComparastate === anioComparaMaximo && state.dia !== '' && state.mes !== '' && state.anio !== '') {
      var mesSeleccion = parseInt(state.mes) + 1;
      var _diasdelmes = monthToDay(fechaMaxima.anio, mesSeleccion);
      var _dias = selectDays(fechaMaxima.dia, _diasdelmes, fechaMaxima.mes, mesSeleccion);
      setNumDias(_dias);
      var mesesMaximo = selectMonths(fechaMaxima.mes, mesesDefault);
      setMeses(mesesMaximo);
    }
    if (state.dia === '' && state.mes === '' && state.anio === '') {
      var _diasdelmes2 = monthToDay(fechaMaxima.anio, fechaMaxima.mes);
      var _dias2 = selectDays(fechaMaxima.dia, _diasdelmes2, fechaMaxima.mes, parseInt(state.mes) + 1);
      setNumDias(_dias2);
      var _mesesMaximo = selectMonths(fechaMaxima.mes, mesesDefault);
      setMeses(_mesesMaximo);
    }
    if (anioComparastate !== anioComparaMaximo && state.mes === '' && state.dia === '' && state.anio === undefined) {
      var _diasdelmes3 = monthToDay(state.anio, 1);
      setNumDias(_diasdelmes3);
      setMeses(mesesDefault);
    }
    if (anioComparastate !== anioComparaMaximo && anioComparastate !== anioComparaMinimo && state.mes !== '' && state.anio !== '' && state.dia === '') {
      var _diasdelmes4 = monthToDay(state.anio, state.mes);
      setNumDias(_diasdelmes4);
    }
    if (anioComparastate !== anioComparaMaximo && anioComparastate !== anioComparaMinimo && state.mes !== '' && state.anio !== '' && (state.mes !== prevStateRef.mes || state.anio !== prevStateRef.anio)) {
      var _diasdelmes5 = monthToDay(state.anio, parseInt(state.mes) + 1);
      setNumDias(_diasdelmes5);
    }
    if (anioComparastate === anioComparaMaximo && state.mes !== '' && state.mes !== undefined && state.dia === '' && state.dia !== undefined) {
      var _diasdelmes6 = monthToDay(state.anio, state.mes);
      setNumDias(_diasdelmes6);
    }
    if (anioComparastate !== anioComparaMaximo && anioComparastate !== anioComparaMinimo && state.dia === "" && state.mes === "" && state.anio !== "") {
      setMeses(mesesDefault);
      var _diasdelmes7 = monthToDay(state.anio, 1);
      setNumDias(_diasdelmes7);
    }
    if (anioComparastate !== anioComparaMaximo && anioComparastate !== anioComparaMinimo && state.mes === "" && state.dia !== '') {
      setMeses(mesesDefault);
    }
    prevErrorRef.current = error;
    prevStateRef.current = state;
  }, [state, fechaMaxima, fechaMinima, error, dateRemote]);
  function AniosElement() {
    return jsx(React.Fragment, null, jsx("div", {
      className: "item",
      css: item
    }, jsx(FormControl$1, {
      variant: "outlined",
      className: classes.formControl
    }, jsx(InputLabel$1, {
      htmlFor: "outlined-age-native-simple"
    }, "A\xF1o"), jsx(Select$2, {
      style: {
        fontSize: fontsize + "px"
      },
      disabled: !disabled,
      autoWidth: true,
      "native": true,
      value: state.anio,
      onChange: handleChange,
      label: "Anio",
      inputProps: {
        name: 'anio',
        id: 'outlined-age-native-simple'
      }
    }, jsx("option", {
      key: "noneyear",
      "aria-label": "None",
      value: ""
    }), year.map(function (row, index) {
      return jsx("option", {
        key: index + 3,
        value: row
      }, row);
    })))));
  }
  function MesesElement() {
    return jsx(React.Fragment, null, jsx("div", {
      className: "item",
      css: item
    }, jsx(FormControl$1, {
      variant: "outlined",
      className: classes.formControl
    }, jsx(InputLabel$1, {
      htmlFor: "outlined-age-native-simple"
    }, "Mes"), jsx(Select$2, {
      style: {
        fontSize: fontsize + "px"
      },
      disabled: !disabled,
      autoWidth: true,
      "native": true,
      value: state.mes,
      onChange: handleChange,
      label: "Mes",
      inputProps: {
        name: 'mes',
        id: 'select-day-picker-mes'
      }
    }, jsx("option", {
      key: "nonemes",
      "aria-label": "None",
      value: ""
    }), meses.map(function (row, index) {
      return jsx("option", {
        key: index + 2,
        value: indexMonth(row, mesesDefault)
      }, row);
    })))));
  }
  function DiasElement() {
    return jsx(React.Fragment, null, jsx("div", {
      className: "item",
      css: item
    }, jsx(FormControl$1, {
      variant: "outlined",
      className: classes.formControl
    }, jsx(InputLabel$1, {
      htmlFor: "outlined-age-native-simple"
    }, "D\xEDa"), jsx(Select$2, {
      style: {
        fontSize: fontsize + "px"
      },
      disabled: !disabled,
      autoWidth: true,
      "native": true,
      value: state.dia,
      onChange: handleChange,
      label: "Dia",
      inputProps: {
        name: 'dia',
        id: 'select-day-picker-dia'
      }
    }, jsx("option", {
      key: "nonedia",
      "aria-label": "None",
      value: ""
    }), numDias.map(function (row, index) {
      return jsx("option", {
        key: index + 1,
        value: row
      }, row);
    })))));
  }
  return jsx("div", null, jsx(FormControl$1, {
    style: {
      paddingLeft: 10
    }
  }, jsx(FormLabel$1, {
    component: "legend"
  }, helperTitle)), jsx("div", {
    className: "contenedor",
    css: contenedor
  }, dateFormat.map(function (row, index) {
    return row === 'dd' && jsx(DiasElement, {
      key: index + 4
    }) || row === 'mm' && jsx(MesesElement, {
      key: index + 5
    }) || row === 'yyyy' && jsx(AniosElement, {
      key: index + 6
    });
  })), error ? jsx(FormControl$1, {
    error: !banderaError,
    style: {
      paddingLeft: 10,
      marginTop: -17
    }
  }, jsx(FormHelperText$1, null, mensajeError)) : jsx(FormControl$1, {
    style: {
      paddingLeft: 10,
      marginTop: -17
    }
  }, jsx(FormHelperText$1, null, helperText)));
};
SelectDatePicker.propTypes = {
  labels: propTypes.array,
  years: propTypes.array,
  monthNames: propTypes.array,
  mensajeError: propTypes.string,
  helperText: propTypes.string,
  disabled: propTypes.bool,
  fechaDefault: propTypes.bool,
  dateFormat: propTypes.array,
  onChange: propTypes.func,
  fontsize: propTypes.number,
  helperTitle: propTypes.string,
  onError: propTypes.func,
  banderaError: propTypes.bool,
  birthday: propTypes.object
};
SelectDatePicker.defaultProps = {
  banderaError: false,
  fechaDefault: false,
  dateFormat: ["dd", "mm", "yyyy"],
  disabled: true,
  labels: ['Año', 'Mes', 'Día'],
  monthNames: ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'],
  years: [2021, 2020, 2019, 2018, 2017],
  mensajeError: 'Error fecha invalida seleccione todos los campos.',
  helperText: 'Préstamos a partir de 18 a 68 años 11 meses',
  minYears: 18,
  maxYears: 74,
  maxMonths: 11,
  fontsize: 12,
  helperTitle: "Fecha de nacimiento"
};
var _templateObject$i;
var Sliderv3 = function Sliderv3(_ref) {
  var altoPerfil = _ref.altoPerfil,
    colorMount = _ref.colorMount,
    valMaximo = _ref.valMaximo,
    valMinimo = _ref.valMinimo,
    avance = _ref.avance,
    colorSlider = _ref.colorSlider,
    title = _ref.title,
    defaultValue = _ref.defaultValue,
    boton = _ref.boton,
    onChange = _ref.onChange,
    otherProps = _ref.otherProps;
  var useStyles = makeStyles(function (theme) {
    return {
      root: {
        color: "" + colorSlider,
        height: 8
      },
      thumb: {
        border: "3px solid " + (altoPerfil ? colorSlider : '#ffffff'),
        marginTop: -8,
        marginLeft: -12,
        margin: '1em auto',
        background: "" + (altoPerfil ? colorSlider : '#ffffff'),
        borderRadius: '50%',
        height: '24px',
        width: '24px',
        boxShadow: '1px 1px 1px 1px gray'
      },
      active: {},
      valueLabel: {
        left: "calc(-50% + 4px)"
      },
      track: {
        height: 13,
        borderRadius: 4
      },
      rail: {
        height: 12,
        borderRadius: 4,
        background: '#ffffff',
        boxShadow: '1px 1px 1px 1px gray'
      }
    };
  });
  var _useState = useState(defaultValue),
    mount = _useState[0],
    setMount = _useState[1];
  var _useState2 = useState({
      max: valMaximo,
      min: valMinimo,
      step: avance,
      defaultValue: defaultValue
    }),
    state = _useState2[0];
  var prevMountRef = useRef();
  var _useState3 = useState(defaultValue),
    setAux = _useState3[1];
  var fontFamilyAmount = altoPerfil ? 'roboto' : 'PT Serif, serif';
  var principal = css(_templateObject$i || (_templateObject$i = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: inline-block;\n    text-align: center;\n    font-family: ", ";\n    font-weight: 800;\n    font-size: 2rem;\n    color: ", ";\n    background: transparent;\n    border: none;\n  "])), fontFamilyAmount, colorMount);
  var classes = useStyles();
  var handleChange = function handleChange(v) {
    setMount(v);
  };
  var handleSliderChangePlus = function handleSliderChangePlus(newValue) {
    if (newValue < state.max) {
      var plus = parseInt(newValue + avance);
      setMount(plus);
      setAux(plus);
    }
  };
  var handleSliderChangeMinus = function handleSliderChangeMinus(newValue) {
    if (newValue > state.min) {
      var minus = parseInt(newValue - avance);
      setMount(minus);
      setAux(minus);
    }
  };
  useEffect(function () {
    if (prevMountRef.current !== mount) {
      onChange(mount);
    }
    prevMountRef.current = mount;
  }, [mount]);
  return jsx("div", {
    style: {
      fontFamily: 'PT Serif, serif',
      width: '100%',
      textAlign: 'center'
    }
  }, jsx(Grid$1, {
    container: true,
    spacing: 1
  }, jsx(Grid$1, {
    item: true,
    xs: 12
  }, jsx(Typography$1, {
    gutterBottom: true
  }, title)), !altoPerfil && jsx(Grid$1, {
    item: true,
    xs: 3
  }, jsx(IconButton$1, {
    style: {
      color: "" + colorMount
    },
    "aria-label": "delete",
    onClick: function onClick() {
      return handleSliderChangeMinus(mount);
    }
  }, jsx(RemoveCircleOutlineIcon, null))), jsx(Grid$1, {
    item: true,
    xs: altoPerfil ? 12 : 6,
    md: altoPerfil ? 12 : 6
  }, jsx("span", {
    id: "amount",
    css: principal
  }, formatNumber(mount))), !altoPerfil && jsx(Grid$1, {
    item: true,
    xs: 3
  }, jsx(IconButton$1, {
    style: {
      color: "" + colorMount
    },
    "aria-label": "delete",
    onClick: function onClick() {
      return handleSliderChangePlus(mount);
    }
  }, jsx(ControlPointIcon, null))), jsx(Grid$1, {
    item: true,
    xs: 1
  }), jsx(Grid$1, {
    item: true,
    xs: 10
  }, jsx(Slider$1, _extends({
    classes: classes
  }, otherProps, {
    "aria-label": "pretto slider",
    defaultValue: defaultValue,
    value: mount,
    onChange: function onChange(event, v) {
      handleChange(v);
    },
    step: state.step,
    max: state.max,
    min: state.min
  }))), jsx(Grid$1, {
    item: true,
    xs: 1
  }), altoPerfil && jsx(Grid$1, {
    item: true,
    xs: 3
  }, jsx(Typography$1, {
    gutterBottom: true
  }, formatNumber(state.min))), altoPerfil && jsx(Grid$1, {
    item: true,
    xs: 6
  }), altoPerfil && jsx(Grid$1, {
    item: true,
    xs: 3
  }, jsx(Typography$1, {
    gutterBottom: true
  }, formatNumber(state.max))), jsx(Grid$1, {
    item: true,
    xs: 1
  }), boton !== null && jsx(Grid$1, {
    item: true,
    xs: 10
  }, boton), jsx(Grid$1, {
    item: true,
    xs: 1
  })));
};
Sliderv3.propTypes = {
  altoPerfil: propTypes.bool,
  boton: propTypes.object,
  title: propTypes.object,
  colorSlider: propTypes.string,
  colorMount: propTypes.string,
  onChange: propTypes.func,
  valMaximo: propTypes.number,
  valMinimo: propTypes.number,
  avance: propTypes.number,
  defaultValue: propTypes.number
};
Sliderv3.defaultProps = {
  title: jsx("p", {
    css: {
      fontFamily: 'PT Serif, serif',
      fontSize: '24px'
    }
  }, jsx("b", null, "\xBFCuanta"), jsx("b", {
    style: {
      color: 'red'
    }
  }, " lana"), " ", jsx("b", null, "necesitas?")),
  colorSlider: '#2196f3',
  colorMount: '#2196f3',
  onChange: function onChange() {},
  valMaximo: 10000,
  valMinimo: 1000,
  avance: 500,
  defaultValue: 5000,
  boton: jsx("div", null)
};
var _templateObject$j;
function ButtonGroupComponent(inProps) {
  var props = useThemeProps({
    props: inProps,
    name: 'MFButtonGroup'
  });
  var _props$helperTitle = props.helperTitle,
    helperTitle = _props$helperTitle === void 0 ? 'Selecciona una opcion' : _props$helperTitle,
    _props$helperText = props.helperText,
    helperText = _props$helperText === void 0 ? 'Requiero mas información' : _props$helperText,
    _props$colorDefault = props.colorDefault,
    colorDefault = _props$colorDefault === void 0 ? '#fff' : _props$colorDefault,
    _props$onClick = props.onClick,
    onClick = _props$onClick === void 0 ? function () {} : _props$onClick,
    _props$botones = props.botones,
    botones = _props$botones === void 0 ? [{
      title: 'Hombre'
    }, {
      title: 'Prefiero no decirlo'
    }, {
      title: 'Mujer'
    }] : _props$botones;
  var _useTheme = useTheme(),
    palette = _useTheme.palette;
  var contenedor = css(_templateObject$j || (_templateObject$j = _taggedTemplateLiteralLoose(["\n    .inactive {\n      background-color: ", ";\n    }\n    .active {\n      background-color: ", ";\n      color: #fff;\n    }\n    .active:focus {\n      background-color: ", ";\n      color: #fff;\n    }\n  "])), colorDefault, palette.primary.main, palette.primary.main);
  var _useState = useState(2),
    value = _useState[0],
    setValue = _useState[1];
  var _useState2 = useState(''),
    extra = _useState2[0],
    setExtra = _useState2[1];
  var handleChange = function handleChange(index, valor) {
    var checkClasses = document.getElementsByClassName('active');
    for (var buttonid = 0; buttonid < checkClasses.length; buttonid++) {
      var inactivefor = checkClasses[buttonid].classList.contains('active');
      if (inactivefor) {
        checkClasses[buttonid].className = checkClasses[buttonid].className.replace(/\bactive\b/g, 'inactive');
      }
    }
    var x = document.getElementById("buttongroup" + index);
    var arrayX = x.classList;
    var inactive = arrayX.contains('inactive');
    if (inactive) {
      x.className = x.className.replace(/\binactive\b/g, 'active');
    }
    setValue(valor);
    setExtra(index);
  };
  useEffect(function () {
    onClick({
      value: value,
      extra: extra
    });
  }, [value]);
  return jsx("div", {
    css: contenedor
  }, jsx(FormControl$1, {
    style: {
      paddingLeft: 10
    }
  }, jsx(FormLabel$1, {
    component: "legend"
  }, helperTitle)), jsx("br", null), jsx(ButtonGroup, null, jsx(Button$1, {
    key: "0",
    id: "buttongroup0",
    className: botones[0].status,
    onClick: function onClick() {
      return handleChange(0, botones[0].title);
    },
    style: {
      border: '1px solid #e7e7e7',
      borderTopLeftRadius: '40px 40px',
      borderBottomLeftRadius: '40px 40px'
    }
  }, jsx("b", null, botones[0].title)), botones.map(function (row, index) {
    if (index > 0 && index < botones.length - 1) {
      return jsx(Button$1, {
        key: index,
        id: "buttongroup" + index,
        className: botones[index].status,
        onClick: function onClick() {
          return handleChange(index, botones[index].title);
        },
        style: {
          border: '1px solid #e7e7e7'
        }
      }, jsx("b", null, botones[index].title));
    }
  }), jsx(Button$1, {
    key: botones.length - 1,
    id: "buttongroup" + (botones.length - 1),
    className: botones[botones.length - 1].status,
    onClick: function onClick() {
      return handleChange(botones.length - 1, botones[botones.length - 1].title);
    },
    style: {
      border: '1px solid #e7e7e7',
      borderTopRightRadius: '40px 40px',
      borderBottomRightRadius: '40px 40px'
    }
  }, jsx("b", null, botones[botones.length - 1].title))), jsx("br", null), jsx("br", null), jsx(FormControl$1, {
    style: {
      paddingLeft: 10,
      marginTop: -17
    }
  }, jsx(FormHelperText$1, null, helperText)));
}
ButtonGroupComponent.propTypes = {
  colorDefault: propTypes.string,
  color: propTypes.string,
  onClick: propTypes.func,
  botones: propTypes.array,
  helperTitle: propTypes.string,
  helperText: propTypes.string
};
var _excluded$7 = ["helper", "options", "label", "fullWidth", "variant", "componentProps", "onChange", "emptyOption"];
function Select(_ref) {
  var helper = _ref.helper,
    options = _ref.options,
    label = _ref.label,
    fullWidth = _ref.fullWidth,
    variant = _ref.variant,
    componentProps = _ref.componentProps,
    onChange = _ref.onChange,
    emptyOption = _ref.emptyOption,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  var _onChange = function _onChange(event) {
    onChange({
      value: event.target.value
    }, event);
  };
  return /*#__PURE__*/React.createElement(FormControl$1, _extends({
    variant: variant,
    fullWidth: fullWidth
  }, componentProps.formControl), /*#__PURE__*/React.createElement(InputLabel$1, null, label), /*#__PURE__*/React.createElement(Select$2, _extends({
    label: label,
    onChange: _onChange
  }, otherProps), emptyOption && /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, "\xA0"), options === null || options === void 0 ? void 0 : options.map(function (option, i) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: i,
      value: option.value
    }, option.text);
  })), helper && /*#__PURE__*/React.createElement(FormHelperText$1, null, helper));
}
Select.defaultProps = {
  componentProps: {}
};
var plazos = {
  FISA: {
    FTCS: {
      labelSemanal: 'Semanal',
      labelQuincenal: 'Quincenal',
      colorDefault: 'Semanal',
      arrayDefault: ['arraySemanas'],
      arraySemanas: [{
        label: ' 26 semanas'
      }, {
        label: ' 40 semanas'
      }, {
        label: ' 52 semanas'
      }, {
        label: ' 65 semanas'
      }, {
        label: ' 78 semanas'
      }],
      arrayQuincenas: [{
        label: ' 24 quincenas'
      }, {
        label: ' 36 quincenas'
      }, {
        label: ' 48 quincenas'
      }]
    },
    MIEN: {
      labelSemanal: 'Semanal',
      colorDefault: 'Semanal',
      arrayDefault: ['arraySemanas'],
      arraySemanas: [{
        label: ' 26 semanas'
      }, {
        label: ' 40 semanas'
      }, {
        label: ' 52 semanas'
      }, {
        label: ' 65 semanas'
      }, {
        label: ' 78 semanas'
      }, {
        label: ' 91 semanas'
      }, {
        label: ' 104 semanas'
      }]
    },
    FTPE: {
      labelMensual: 'Mensual',
      colorDefault: 'Mensual',
      arrayDefault: ['arrayMeses'],
      arrayMeses: [{
        label: ' 6 meses'
      }, {
        label: ' 12 meses'
      }, {
        label: ' 18 meses'
      }, {
        label: ' 24 meses'
      }, {
        label: ' 36 meses'
      }]
    }
  },
  AEF: {
    222: {
      labelSemanal: 'Semanal',
      labelQuincenal: 'Quincenal',
      labelMensual: 'Mensual',
      colorDefault: 'Quincenal',
      arrayDefault: ['arrayQuincenas'],
      arraySemanas: [{
        label: ' 12 semanas'
      }, {
        label: ' 24 semanas'
      }, {
        label: ' 39 semanas'
      }, {
        label: ' 52 semanas'
      }, {
        label: ' 65 semanas'
      }, {
        label: ' 78 semanas'
      }, {
        label: ' 91 semanas'
      }, {
        label: ' 104 semanas'
      }, {
        label: ' 117 semanas'
      }, {
        label: ' 130 semanas'
      }, {
        label: ' 143 semanas'
      }, {
        label: ' 156 semanas'
      }],
      arrayQuincenas: [{
        label: ' 6 quincenas'
      }, {
        label: ' 12 quincenas'
      }, {
        label: ' 18 quincenas'
      }, {
        label: ' 24 quincenas'
      }, {
        label: ' 30 quincenas'
      }, {
        label: ' 36 quincenas'
      }, {
        label: ' 42 quincenas'
      }, {
        label: ' 48 quincenas'
      }, {
        label: ' 54 quincenas'
      }, {
        label: ' 60 quincenas'
      }, {
        label: ' 66 quincenas'
      }, {
        label: ' 72 quincenas'
      }],
      arrayMeses: [{
        label: ' 3 meses'
      }, {
        label: ' 6 meses'
      }, {
        label: ' 9 meses'
      }, {
        label: ' 12 meses'
      }, {
        label: ' 15 meses'
      }, {
        label: ' 18 meses'
      }, {
        label: ' 21 meses'
      }, {
        label: ' 24 meses'
      }, {
        label: ' 27 meses'
      }, {
        label: ' 30 meses'
      }, {
        label: ' 33 meses'
      }, {
        label: ' 36 meses'
      }]
    },
    225: {
      labelSemanal: 'Semanal',
      labelQuincenal: 'Quincenal',
      labelMensual: 'Mensual',
      colorDefault: 'Quincenal',
      arrayDefault: ['arrayQuincenas'],
      arraySemanas: [{
        label: ' 12 semanas'
      }, {
        label: ' 24 semanas'
      }, {
        label: ' 39 semanas'
      }, {
        label: ' 52 semanas'
      }, {
        label: ' 65 semanas'
      }, {
        label: ' 78 semanas'
      }, {
        label: ' 91 semanas'
      }, {
        label: ' 104 semanas'
      }, {
        label: ' 117 semanas'
      }, {
        label: ' 130 semanas'
      }, {
        label: ' 143 semanas'
      }, {
        label: ' 156 semanas'
      }],
      arrayQuincenas: [{
        label: ' 6 quincenas'
      }, {
        label: ' 12 quincenas'
      }, {
        label: ' 18 quincenas'
      }, {
        label: ' 24 quincenas'
      }, {
        label: ' 30 quincenas'
      }, {
        label: ' 36 quincenas'
      }, {
        label: ' 42 quincenas'
      }, {
        label: ' 48 quincenas'
      }, {
        label: ' 54 quincenas'
      }, {
        label: ' 60 quincenas'
      }, {
        label: ' 66 quincenas'
      }, {
        label: ' 72 quincenas'
      }],
      arrayMeses: [{
        label: ' 3 meses'
      }, {
        label: ' 6 meses'
      }, {
        label: ' 9 meses'
      }, {
        label: ' 12 meses'
      }, {
        label: ' 15 meses'
      }, {
        label: ' 18 meses'
      }, {
        label: ' 21 meses'
      }, {
        label: ' 24 meses'
      }, {
        label: ' 27 meses'
      }, {
        label: ' 30 meses'
      }, {
        label: ' 33 meses'
      }, {
        label: ' 36 meses'
      }]
    },
    539: {
      labelMensual: 'Mensual',
      colorDefault: 'Mensual',
      arrayDefault: ['arrayMeses'],
      arrayMeses: [{
        label: ' 6 meses'
      }, {
        label: ' 12 meses'
      }, {
        label: ' 18 meses'
      }, {
        label: ' 24 meses'
      }, {
        label: ' 36 meses'
      }]
    }
  },
  FINDEP: {
    FTCS: {
      labelQuincenal: 'Quincenal',
      colorDefault: 'Quincenal',
      arrayDefault: ['arrayQuincenas'],
      arrayQuincenas: [{
        label: ' 6 quincenas'
      }, {
        label: ' 12 quincenas'
      }, {
        label: ' 18 quincenas'
      }, {
        label: ' 24 quincenas'
      }]
    },
    MIEN: {
      labelSemanal: 'Quincenal',
      colorDefault: 'Quincenal',
      arrayDefault: ['arrayQuincenas'],
      arrayQuincenas: [{
        label: ' 6 quincenas'
      }, {
        label: ' 12 quincenas'
      }, {
        label: ' 18 quincenas'
      }, {
        label: ' 24 quincenas'
      }]
    }
  },
  PRESTASUMA: {
    FTCS: {
      labelSemanal: 'Semanal',
      labelQuincenal: 'Quincenal',
      colorDefault: 'Semanal',
      arrayDefault: ['arraySemanas'],
      arraySemanas: [{
        label: ' 26 semanas'
      }, {
        label: ' 40 semanas'
      }, {
        label: ' 52 semanas'
      }, {
        label: ' 65 semanas'
      }, {
        label: ' 78 semanas'
      }],
      arrayQuincenas: [{
        label: ' 24 quincenas'
      }, {
        label: ' 36 quincenas'
      }, {
        label: ' 48 quincenas'
      }]
    },
    MIEN: {
      labelSemanal: 'Semanal',
      colorDefault: 'Semanal',
      arrayDefault: ['arraySemanas'],
      arraySemanas: [{
        label: ' 26 semanas'
      }, {
        label: ' 40 semanas'
      }, {
        label: ' 52 semanas'
      }, {
        label: ' 65 semanas'
      }, {
        label: ' 78 semanas'
      }, {
        label: ' 91 semanas'
      }, {
        label: ' 104 semanas'
      }]
    }
  },
  CREDICONSTRUYE: {
    FTCS: {
      labelSemanal: 'Semanal',
      labelQuincenal: 'Quincenal',
      colorDefault: 'Semanal',
      arrayDefault: ['arraySemanas'],
      arraySemanas: [{
        label: ' 26 semanas'
      }, {
        label: ' 40 semanas'
      }, {
        label: ' 52 semanas'
      }, {
        label: ' 65 semanas'
      }, {
        label: ' 78 semanas'
      }],
      arrayQuincenas: [{
        label: ' 24 quincenas'
      }, {
        label: ' 36 quincenas'
      }, {
        label: ' 48 quincenas'
      }]
    },
    MIEN: {
      labelSemanal: 'Semanal',
      colorDefault: 'Semanal',
      arrayDefault: ['arraySemanas'],
      arraySemanas: [{
        label: ' 26 semanas'
      }, {
        label: ' 40 semanas'
      }, {
        label: ' 52 semanas'
      }, {
        label: ' 65 semanas'
      }, {
        label: ' 78 semanas'
      }, {
        label: ' 91 semanas'
      }, {
        label: ' 104 semanas'
      }]
    }
  },
  PRESTAUNICO: {
    FTCS: {
      labelSemanal: 'Semanal',
      labelQuincenal: 'Quincenal',
      colorDefault: 'Semanal',
      arrayDefault: ['arraySemanas'],
      arraySemanas: [{
        label: ' 26 semanas'
      }, {
        label: ' 40 semanas'
      }, {
        label: ' 52 semanas'
      }, {
        label: ' 65 semanas'
      }, {
        label: ' 78 semanas'
      }],
      arrayQuincenas: [{
        label: ' 24 quincenas'
      }, {
        label: ' 36 quincenas'
      }, {
        label: ' 48 quincenas'
      }]
    },
    MIEN: {
      labelSemanal: 'Semanal',
      colorDefault: 'Semanal',
      arrayDefault: ['arraySemanas'],
      arraySemanas: [{
        label: ' 26 semanas'
      }, {
        label: ' 40 semanas'
      }, {
        label: ' 52 semanas'
      }, {
        label: ' 65 semanas'
      }, {
        label: ' 78 semanas'
      }, {
        label: ' 91 semanas'
      }, {
        label: ' 104 semanas'
      }]
    }
  },
  AFI: {
    2: {
      labelSemanal: 'Catorcenal',
      labelQuincenal: 'Quincenal',
      labelMensual: 'Mensual',
      colorDefault: 'Mensual',
      arrayDefault: ['arrayMeses'],
      arrayMeses: [{
        label: ' 12 meses'
      }, {
        label: ' 18 meses'
      }, {
        label: ' 24 meses'
      }, {
        label: ' 36 meses'
      }, {
        label: ' 48 meses'
      }, {
        label: ' 60 meses'
      }]
    }
  }
};
export { ButtonDegrade, ButtonGroupComponent as ButtonGroup, CardElevation, CardProgres, CardTasks, CustomizedSteppers as CustomizedStepper, DatePicker$1 as DatePicker, Encuesta, FileUpload, Footer, SimpleSelect as FormaPago, Header, InputNip, MaterialInput$1 as MaterialInput, MenuLayout$1 as MenuLayout, ModalInfo, Oferta, Referencia, Select, SelectDatePicker, SelectIcon, SimpleAccordion, SliderRange, Sliderv3, TitleIcon, plazos };